export default {
  'header.homepage': 'Homepage',
  'header.workspace': 'Area di Lavoro',
  'login.title': 'Seedance',
  'login.welcome': 'Benvenuto su Seedance',
  'login.description': 'Seedance è la tua piattaforma di generazione video con IA. Servizi sicuri e convenienti. Accedi a tutti i tuoi file ovunque e in qualsiasi momento.',
  'login.email.placeholder': 'Email o nome utente',
  'login.password.placeholder': 'Password',
  'login.button': 'Accedi',
  'login.loading': 'Accesso in corso...',
  'login.divider': 'o',
  'login.signup': 'Non hai un account?',
  'login.signup.link': 'Registrati',
  'login.error.default': 'Accesso fallito, riprova più tardi',
  'login.success': 'Accesso effettuato',
  'login.forgotPassword': 'Password dimenticata?',
  'login.forgotPassword.link': 'Reimposta qui',
  'login.rememberPassword': 'Ricorda password',
  'login.social.comingSoon': 'Questo metodo di accesso arriverà presto',
  'captcha.placeholder': 'Codice captcha',
  'captcha.refresh': 'Aggiorna captcha',
  'auth.modal.title': 'Accesso richiesto',
  'auth.modal.content': 'La sessione è scaduta o non hai effettuato l\'accesso. Accedi per continuare.',
  'auth.modal.ok': 'Vai al login',
  'auth.modal.cancel': 'Più tardi',
  'signup.page.title': 'Registrazione - Seedance',
  'signup.title': 'Seedance',
  'signup.welcome': 'Benvenuto su Seedance',
  'signup.description': 'Crea il tuo account e inizia il tuo viaggio nella creazione con IA',
  'signup.feature.ai': 'Alimentato da IA',
  'signup.feature.video': 'Creazione Video',
  'signup.feature.fast': 'Generazione Veloce',
  'signup.feature.creative': 'Creatività Illimitata',
  'signup.username.placeholder': 'Inserisci nome utente',
  'signup.email.placeholder': 'Inserisci email',
  'signup.password.placeholder': 'Inserisci password',
  'signup.confirmPassword.placeholder': 'Conferma password',
  'signup.inviteCode.placeholder': 'Codice invito (opzionale)',
  'signup.button': 'Registrati',
  'signup.loading': 'Registrazione in corso...',
  'signup.login': 'Hai già un account?',
  'signup.login.link': 'Accedi',
  'signup.error.passwordMismatch': 'Le password non corrispondono',
  'signup.error.default': 'Registrazione fallita, riprova più tardi',
  'signup.success': 'Registrazione completata',
  'signup.username.rule.length': 'Il nome utente deve essere compreso tra 4 e 10 caratteri',
  'signup.username.rule.format': 'Sono consentiti solo lettere, numeri, trattini bassi e trattini',
  'signup.password.rule.length': 'La password deve essere compresa tra 6 e 20 caratteri',
  'signup.password.rule.lowercase': 'Deve contenere lettere minuscole',
  'signup.password.rule.uppercase': 'Deve contenere lettere maiuscole',
  'signup.password.rule.number': 'Deve contenere numeri',
  'signup.password.rule.special': 'Deve contenere caratteri speciali',
  'resetPassword.page.title': 'Reimposta password - Seedance',
  'resetPassword.page.description': 'Reimposta la password del tuo account Seedance',
  'resetPassword.title': 'Reimposta password',
  'resetPassword.email.placeholder': 'Inserisci il tuo indirizzo email',
  'resetPassword.code.placeholder': 'Inserisci il codice di verifica',
  'resetPassword.password.placeholder': 'Inserisci la nuova password',
  'resetPassword.button': 'Reimposta',
  'resetPassword.button.loading': 'Reimpostazione in corso...',
  'resetPassword.backToLogin': 'Torna al login',
  'resetPassword.sendCode': 'Ottieni codice',
  'resetPassword.sendCode.sending': 'Invio in corso...',
  'resetPassword.sendCode.retry': 'Riprova tra {seconds}s',
  'resetPassword.error.emailRequired': 'Inserisci il tuo indirizzo email',
  'resetPassword.error.codeRequired': 'Inserisci il codice di verifica',
  'resetPassword.error.passwordRequired': 'Inserisci la nuova password',
  'resetPassword.error.passwordLength': 'La password deve essere tra 6 e 20 caratteri',
  'resetPassword.error.codeLength': 'Il codice di verifica deve essere di 6 cifre',
  'resetPassword.success.codeSent': 'Il codice di verifica è stato inviato alla tua email',
  'resetPassword.success.reset': 'Password reimpostata con successo',
  'resetPassword.error.sendFailed': 'Errore nell\'invio del codice di verifica, riprova più tardi',
  'resetPassword.error.resetFailed': 'Errore nella reimpostazione della password, riprova più tardi',
  'resetPassword.error.incomplete': 'Per favore, compila tutti i campi obbligatori',
  'resetPassword.subtitle': 'Inserisci il tuo indirizzo email e una nuova password per reimpostare l\'accesso al tuo account.',
  'resetPassword.email.label': 'Email',
  'resetPassword.code.label': 'Codice di verifica',
  'resetPassword.password.label': 'Nuova password',
  'resetPassword.success.title': 'Reimpostazione riuscita',
  'resetPassword.success.description': 'La tua password è stata aggiornata con successo. Ora puoi accedere con la tua nuova password.',
  'resetPassword.goToLogin': 'Vai al login',
  'resetPassword.promo.title': 'Proteggi il tuo account, custodisci la tua creatività.',
  'resetPassword.promo.description': 'Implementiamo protocolli di sicurezza di livello bancario per garantire che i tuoi dati e le tue creazioni rimangano esclusivamente tuoi.',
  'signup.verificationCode.placeholder': 'Inserisci il codice di verifica',
  'signup.verificationCode.send': 'Ottieni codice',
  'signup.verificationCode.sending': 'Invio in corso...',
  'signup.verificationCode.retry': 'Riprova tra {seconds}s',
  'signup.verificationCode.success': 'Codice di verifica inviato',
  'signup.verificationCode.error': 'Invio del codice fallito',
  'signup.verificationCode.required': 'Inserisci il codice di verifica',
  'signup.verificationCode.invalid': 'Formato del codice di verifica non valido',
  'signup.error.emailRequired': 'Per favore inserisci il tuo indirizzo email',
  'signup.announcement': 'La funzione di registrazione è in manutenzione oggi!',
  'sidebar.create': 'Crea',
  'sidebar.allFiles': 'Tutti i file',
  'sidebar.starred': 'Preferiti',
  'sidebar.folders': 'Cartelle',
  'sidebar.trash': 'Cestino',
  'sidebar.decrypt': 'Strumento di decrittazione',
  'sidebar.promptMarket': 'Prompt Market',
  'sidebar.channels': 'Canali',
  'sidebar.dailyChallenge': 'Sfida Giornaliera',
  'sidebar.mediaTools': 'Strumenti Media',
  'sidebar.storageNodes': 'Nodi di Archiviazione',
  'create.tab.textToImage': 'Testo a Immagine',
  'create.tab.textToVideo': 'Testo a Video',
  'create.tab.imageToImage': 'Immagine a Immagine',
  'create.tab.imageToVideo': 'Immagine a Video',
  'create.tab.seedanceVideo': 'Seedance Immagine a Video',
  'create.seedance.title': 'Seedance Immagine a Video',
  'create.seedance.subtitle': 'ByteDance Doubao Seedance 1.5, generazione di video brevi guidata dall\'immagine',
  'create.seedance.noModel': 'Nessun modello Seedance disponibile. Configurare nel pannello di amministrazione.',
  'create.seedance.cameraFixed': 'Fotocamera fissa',
  'create.seedance.cameraFixed.true': 'Sì (fissa)',
  'create.seedance.cameraFixed.false': 'No (dinamica)',
  'create.seedance.watermark': 'Aggiungi filigrana',
  'create.seedance.watermark.true': 'Sì',
  'create.seedance.watermark.false': 'No',
  'create.textToImage.title': 'Testo a Immagine',
  'create.textToImage.subtitle': 'Inserisci una descrizione e lascia che l\'IA disegni l\'immagine nella tua mente',
  'create.textToImage.description': 'Genera immagini da descrizioni testuali. Questa funzionalità è in fase di sviluppo...',
  'create.textToVideo.title': 'Testo a Video',
  'create.textToVideo.subtitle': 'Inserisci descrizioni di scene e controlli della fotocamera per generare video di alta qualità',
  'create.textToVideo.description': 'Genera video da descrizioni testuali. Questa funzionalità è in fase di sviluppo...',
  'create.imageToImage.title': 'Immagine a Immagine',
  'create.imageToImage.description': 'Genera nuove immagini da immagini di riferimento. Questa funzionalità è in fase di sviluppo...',
  'create.imageToVideo.title': 'Immagine a Video',
  'create.imageToVideo.description': 'Genera video da immagini di riferimento. Questa funzionalità è in fase di sviluppo...',
  'sidebar.feedback': 'Feedback',
  'sidebar.about': 'Info',
  'sidebar.productLog': 'Aggiornamenti',
  'promptMarket.title': 'Prompt Market',
  'promptMarket.subtitle': 'Esplora le ricette di ispirazione AI dei migliori creatori e libera il tuo potenziale creativo',
  'promptMarket.searchPlaceholder': 'Cerca prompt, stili, modelli...',
  'promptMarket.search': 'Cerca',
  'promptMarket.all': 'Tutti',
  'promptMarket.tabAll': 'Consigliati',
  'promptMarket.tabImage': 'Testo a immagine',
  'promptMarket.tabVideo': 'Testo a video',
  'promptMarket.tabAudio': 'Testo a musica',
  'promptMarket.sortLatest': 'Più recenti',
  'promptMarket.sortHot': 'Popolari',
  'promptMarket.sortSales': 'Più venduti',
  'promptMarket.publish': 'Pubblica',
  'promptMarket.empty': 'Nessun contenuto. Sii il primo a pubblicare!',
  'promptMarket.free': 'Gratis',
  'promptMarket.token': 'TOKEN',
  'promptMarket.loadFailed': 'Caricamento fallito',
  'promptMarket.listSuccess': 'Pubblicato con successo',
  'promptMarket.listFailed': 'Pubblicazione fallita',
  'market.label': 'MERCATO PROMPT',
  'market.h1': 'Libera la tua',
  'market.h1.highlight': 'intelligenza creativa.',
  'market.sub': 'La destinazione premium per i prompt IA: immagine, video e musica. Ricette verificate per OpenAI, Google, Midjourney, Runway, Kling, Luma, Suno, ElevenLabs e altri. Smetti di indovinare, inizia a creare.',
  'market.providers.title': 'Compatibile con i principali modelli e piattaforme',
  'market.card1.title': 'Integrazione istantanea',
  'market.card1.desc': 'Salta la curva di apprendimento del prompt engineering. Importa prompt collaudati nel tuo flusso di lavoro con un clic.',
  'market.card2.title': 'Monetizza la creatività',
  'market.card2.desc': 'Trasforma i tuoi migliori prompt in reddito passivo. Unisciti a migliaia di creatori che guadagnano con la loro expertise IA.',
  'market.card3.title': 'Qualità verificata',
  'market.card3.desc': 'Ogni listing è revisionato e testato manualmente. Garantiamo risultati coerenti su diversi modelli.',
  'market.card4.title': 'Esplora il laboratorio',
  'market.card4.desc': 'Scopri oltre 10.000 asset generati dalla community.',
  'market.cta': 'Avvia il Mercato Prompt',
  'home.mediaTools.title': 'Strumenti media',
  'home.mediaTools.subtitle': 'Uso online, senza installazione. Elabora facilmente immagini, video e audio.',
  'home.mediaTools.toolSuffix': '',
  'home.mediaTools.imageCompress.title': 'Compressione immagini',
  'home.mediaTools.imageCompress.description': 'Compressione intelligente mantenendo la qualità. Elaborazione batch.',
  'home.mediaTools.videoCompress.title': 'Compressione video',
  'home.mediaTools.videoCompress.description': 'Compressione efficiente con risoluzione e bitrate personalizzabili. Formati multipli.',
  'home.mediaTools.audioCompress.title': 'Compressione audio',
  'home.mediaTools.audioCompress.description': 'Ottimizza la dimensione mantenendo la chiarezza. MP3, AAC e altro.',
  'filelist.column.name': 'Nome',
  'filelist.column.size': 'Dimensione',
  'filelist.column.updateTime': 'Modificato',
  'filelist.column.recycletime': 'Data eliminazione',
  'filelist.column.actions': 'Azioni',
  'filelist.total': 'Totale {total} elementi',
  'filelist.action.upload': 'Carica',
  'filelist.action.newFolder': 'Nuova cartella',
  'filelist.action.refresh': 'Aggiorna',
  'filelist.action.search': 'Cerca file',
  'filelist.action.batchDownload': 'Scarica',
  'filelist.action.batchDelete': 'Elimina',
  'filelist.action.download': 'Scarica',
  'filelist.action.preview': 'Anteprima',
  'filelist.action.rename': 'Rinomina',
  'filelist.selected': '{count} selezionati',
  'page.cloudDrive.title': 'Il mio Cloud Drive',
  'page.cloudDrive.description': 'AIMATEX Cloud Drive - Archivia e gestisci i tuoi file in modo sicuro',
  'modal.fileUpload.title': 'Carica file',
  'modal.fileUpload.dragText': 'Trascina i file qui o clicca per caricare',
  'modal.fileUpload.start': 'Avvia caricamento',
  'modal.fileUpload.cancel': 'Annulla',
  'modal.fileUpload.clear': 'Svuota lista',
  'modal.fileUpload.encrypt': 'Cripta selezionati',
  'modal.fileUpload.addMore': 'Aggiungi',
  'modal.fileUpload.remove': 'Rimuovi',
  'modal.fileUpload.error.noSelection': 'Seleziona i file da rimuovere',
  'modal.fileUpload.error.noEncryption': 'Seleziona i file da criptare',
  'modal.fileUpload.error.noClear': 'Nessun file da cancellare',
  'modal.fileUpload.error.noStart': 'Nessun file da caricare',
  'modal.fileUpload.error.noCancel': 'Nessun caricamento in corso da annullare',
  'modal.fileUpload.error.fileSize': 'Dimensione file superata',
  'modal.fileUpload.error.fileType': 'Tipo di file non supportato',
  'modal.fileUpload.error.maxCount': 'Numero massimo di file superato',
  'modal.fileUpload.duplicate.title': 'Il file esiste già',
  'modal.fileUpload.duplicate.skip': 'Salta',
  'modal.fileUpload.duplicate.replace': 'Sostituisci',
  'modal.fileUpload.duplicate.rename': 'Rinomina',
  'modal.fileUpload.status.pending': 'In attesa',
  'modal.fileUpload.status.uploading': 'Caricamento in corso',
  'modal.fileUpload.status.success': 'Completato',
  'modal.fileUpload.status.error': 'Errore',
  'modal.fileUpload.status.cancelled': 'Annullato',
  'modal.fileUpload.status.duplicated': 'Duplicato',
  'modal.fileUpload.table.filename': 'Nome file',
  'modal.fileUpload.table.size': 'Dimensione',
  'modal.fileUpload.table.status': 'Stato',
  'modal.fileUpload.table.progress': 'Avanzamento',
  'modal.fileUpload.table.actions': 'Azioni',
  'modal.fileUpload.speed': 'Velocità di caricamento',
  'modal.fileUpload.remainingTime': 'Tempo rimanente',
  'modal.fileUpload.total.progress': 'Avanzamento totale',
  'modal.fileUpload.error.message': 'Errore di caricamento: {message}',
  'modal.fileUpload.confirm.clear': 'Vuoi svuotare la lista di caricamento?',
  'modal.fileUpload.confirm.cancel': 'Vuoi annullare il caricamento?',
  'modal.fileUpload.clear.mobile': 'Svuota',
  'modal.fileUpload.encrypt.mobile': 'Cripta',
  'modal.fileUpload.addMore.mobile': 'Aggiungi',
  'productLog.title': 'Aggiornamenti del prodotto',
  'decrypt.fileList.column.name': 'Nome file',
  'decrypt.fileList.column.status': 'Stato',
  'decrypt.fileList.column.actions': 'Azioni',
  'decrypt.fileList.status.pending': 'In attesa',
  'decrypt.fileList.status.decrypting': 'Decrittazione in corso',
  'decrypt.fileList.status.success': 'Completato',
  'decrypt.fileList.status.error': 'Errore',
  'decrypt.fileList.action.info': 'Info',
  'decrypt.fileList.empty': 'Nessun file, aggiungi file da decrittare',
  'common.unknown': 'Sconosciuto',
  'common.philosophy': 'La tecnologia dovrebbe servire il popolo',
  'common.speed': 'Velocità',
  'common.timeSpent': 'Tempo trascorso',
  'common.remaining': 'Rimanente',
  'security.features.title': 'Funzionalità di sicurezza',
  'security.features.localDecryption.title': 'Decrittazione locale',
  'security.features.localDecryption.description': 'Tutte le operazioni di decrittazione vengono eseguite localmente nel tuo browser, il contenuto del file e la password non lasciano mai il tuo dispositivo',
  'security.features.militaryEncryption.title': 'Crittografia militare',
  'security.features.militaryEncryption.description': 'Utilizza l\'algoritmo di crittografia AES-256-CBC, lo standard di crittografia simmetrica più sicuro che può resistere a tutti gli attacchi noti',
  'security.features.privacyProtection.title': 'Protezione della privacy',
  'security.features.privacyProtection.description': 'Meccanismo rigoroso di protezione della privacy, nessuna password di decrittazione viene salvata, nessun contenuto del file viene registrato',
  'security.features.smartDecryption.title': 'Decrittazione intelligente a blocchi',
  'security.features.smartDecryption.description': 'La tecnologia di decrittazione intelligente a blocchi migliora significativamente la velocità di decrittazione riducendo l\'utilizzo della memoria',
  'security.features.learnMore': 'Scopri di più',
  'security.features.modal.title': 'Dettagli funzionalità di sicurezza',
  'security.features.modal.close': 'Chiudi',
  'decrypt.security.modal.title': 'Avviso di sicurezza',
  'decrypt.security.modal.description': 'Tutte le operazioni di decrittazione vengono eseguite localmente, la tua password e il contenuto del file non verranno mai inviati al server',
  'decrypt.security.modal.vip.title': 'Come utente VIP, puoi:',
  'decrypt.security.modal.vip.feature1': 'Decrittare file di qualsiasi dimensione',
  'decrypt.security.modal.vip.feature2': 'Usare la decrittazione intelligente a blocchi per una migliore efficienza',
  'decrypt.security.modal.vip.feature3': 'Supportare la decrittazione in batch di file di grandi dimensioni',
  'decrypt.security.modal.free.title': 'Importante: Il processo di decrittazione richiede circa 3 volte la dimensione del file in memoria del browser.',
  'decrypt.security.modal.free.feature1': 'Gli utenti gratuiti sono limitati a 4GB per file',
  'decrypt.security.modal.free.feature2': 'Passa a VIP per decrittare file di qualsiasi dimensione',
  'decrypt.security.modal.free.feature3': 'Se il browser si blocca, considera di passare a VIP per utilizzare la decrittazione a blocchi',
  'security.diagram.plaintext.block1': 'Blocco di testo in chiaro 1',
  'security.diagram.plaintext.block2': 'Blocco di testo in chiaro 2',
  'security.diagram.ciphertext.block1': 'Blocco di testo cifrato 1',
  'security.diagram.ciphertext.block2': 'Blocco di testo cifrato 2',
  'security.diagram.key': 'Chiave',
  'security.diagram.aes.encryption': 'Crittografia AES',
  'security.diagram.xor.operation': 'Operazione XOR',
  'security.diagram.iv': 'Vettore di inizializzazione',
  'decrypt.upload.dragText': 'Clicca o trascina i file',
  'decrypt.upload.hint': 'Supporta file .encrypted, massimo {maxSize} per file',
  'decrypt.upload.button.decrypt': 'Decripta selezionati',
  'decrypt.upload.button.clear': 'Svuota lista',
  'page.decrypt.title': 'Strumento di decrittazione file MyStorage',
  'page.decrypt.subtitle': 'Decripta i tuoi file in modo sicuro',
  'page.decrypt.helmet.title': 'Strumento di decrittazione - MyStorage',
  'page.decrypt.helmet.description': 'Strumento sicuro di decrittazione - Decripta i tuoi file localmente nel browser per proteggere la tua privacy',
  'decrypt.fileInfo.modal.title': 'Informazioni File',
  'decrypt.fileInfo.modal.close': 'Chiudi',
  'decrypt.fileInfo.name': 'Nome File',
  'decrypt.fileInfo.size': 'Dimensione File',
  'decrypt.fileInfo.type': 'Tipo File',
  'decrypt.fileInfo.lastModified': 'Ultima Modifica',
  'decrypt.fileInfo.status': 'Stato',
  'decrypt.fileInfo.progress': 'Progresso',
  'decrypt.fileInfo.speed': 'Velocità',
  'decrypt.fileInfo.timeRemaining': 'Tempo Rimanente',
  'decrypt.fileInfo.timeSpent': 'Tempo Trascorso',
  'decrypt.fileInfo.error': 'Messaggio di Errore',
  'decrypt.password.modal.title': 'Inserisci password di decrittazione',
  'decrypt.password.modal.placeholder': 'Inserisci password',
  'decrypt.password.modal.hint': 'Inserisci la password impostata durante la crittazione, verrà usata solo per la decrittazione locale',
  'decrypt.message.invalidFile': 'Seleziona solo file .encrypted',
  'decrypt.message.duplicate': 'Il file "{filename}" esiste già, duplicato rimosso automaticamente',
  'decrypt.message.oversizeTitle': 'Dimensione file superata',
  'decrypt.message.oversizeContent': 'I seguenti file superano il limite gratuito (4GB):',
  'decrypt.message.oversizeHint': 'Passa a VIP per decrittare file di qualsiasi dimensione',
  'decrypt.message.selectFile': 'Seleziona i file da decrittare',
  'decrypt.message.enterPassword': 'Inserisci la password di decrittazione',
  'decrypt.message.decryptSuccess': 'Il file {filename} è stato salvato',
  'decrypt.message.saveCancel': 'Salvataggio del file {filename} annullato',
  'decrypt.message.downloadSuccess': 'Il file {filename} è stato salvato nella cartella download',
  'decrypt.message.decryptError': 'Errore durante la decrittazione del file {filename}: {error}',
  'decrypt.message.batchError': 'Decrittazione in batch fallita, riprova',
  'sideMenu.storageInfo.title': 'Spazio di archiviazione',
  'sideMenu.storageInfo.usage': 'Utilizzato {used} / Totale {total}',
  'sideMenu.storageStats.title': 'Statistiche di archiviazione',
  'sideMenu.storageStats.overview': 'Panoramica',
  'sideMenu.storageStats.totalFiles': 'Totale file',
  'sideMenu.storageStats.totalSize': 'Dimensione totale',
  'sideMenu.storageStats.fileTypes': 'Distribuzione tipi di file',
  'sideMenu.storageStats.providers': 'Fornitori di servizi',
  'common.default': 'Predefinito',
  'common.regionCode': 'Codice regione',
  'common.nodeType': 'Tipo di nodo',
  'common.storageUsed': 'Spazio utilizzato',
  'common.storageAvailable': 'Spazio disponibile',
  'common.storageLimit': 'Capacità totale',
  'common.storageUsageDetail': 'Utilizzato {used} / Totale {total}',
  'common.defaultNode': 'Nodo predefinito',
  'common.confirm': 'Conferma',
  'common.cancel': 'Annulla',
  'common.latency': 'Latenza',
  'common.retry': 'Riprova',
  'cloudDrive.nodeSelect.title': 'Seleziona nodo di archiviazione',
  'cloudDrive.nodeSelect.addNode': 'Aggiungi nodo di archiviazione',
  'cloudDrive.nodeSelect.deleteConfirm.title': 'Conferma eliminazione nodo',
  'cloudDrive.nodeSelect.deleteConfirm.content': 'Sei sicuro di voler eliminare il nodo "{nodeName}"? Questa azione non può essere annullata!',
  'cloudDrive.nodeSelect.deleteSuccess': 'Nodo eliminato con successo',
  'cloudDrive.nodeSelect.deleteFailed': 'Errore durante l\'eliminazione del nodo',
  
  // Creazione nodo
  'cloudDrive.nodeCreate.title': 'Aggiungi nodo di archiviazione',
  'cloudDrive.nodeCreate.selectProvider': 'Seleziona fornitore cloud',
  'cloudDrive.nodeCreate.nodeName': 'Nome del nodo',
  'cloudDrive.nodeCreate.nodeNamePlaceholder': 'Lasciare vuoto per utilizzare il nome predefinito',
  'cloudDrive.nodeCreate.nameMaxLength': 'Il nome del nodo non può superare i 50 caratteri',
  'cloudDrive.nodeCreate.noProviders': 'Nessun fornitore cloud disponibile',
  'cloudDrive.nodeCreate.pingLatency': 'Latenza {value} ms',
  'cloudDrive.nodeCreate.pingTesting': 'Test della latenza in corso...',
  'cloudDrive.nodeCreate.pingFailed': 'Test della latenza fallito',
  'cloudDrive.nodeCreate.pingUnavailable': 'Test della latenza non disponibile',
  'cloudDrive.nodeCreate.sortByLatency': 'Ordina per latenza',
  'cloudDrive.nodeCreate.selectRegion': 'Seleziona regione',
  'cloudDrive.nodeCreate.selectedRegion': 'Regione selezionata',
  'cloudDrive.nodeCreate.noRegions': 'Nessuna regione disponibile',
  'cloudDrive.nodeCreate.selectProviderPlaceholder': 'Seleziona un fornitore cloud',
  'cloudDrive.nodeCreate.selectProviderRequired': 'Seleziona prima un fornitore cloud',
  'cloudDrive.nodeCreate.selectRegionRequired': 'Seleziona prima una regione',
  'cloudDrive.nodeCreate.loadProvidersFailed': 'Errore nel caricamento della lista dei fornitori cloud',
  'cloudDrive.nodeCreate.loadRegionsFailed': 'Errore nel caricamento della lista delle regioni',
  'cloudDrive.nodeCreate.nodeType': 'Tipo di nodo',
  'cloudDrive.nodeCreate.nodeType.standard': 'Archiviazione standard',
  'cloudDrive.nodeCreate.nodeType.lowFreq': 'Archiviazione a bassa frequenza',
  'cloudDrive.nodeCreate.nodeType.archive': 'Archiviazione di archivio',
  'cloudDrive.nodeCreate.storageLimit': 'Limite di archiviazione',
  'cloudDrive.nodeCreate.storageLimitRequired': 'Inserisci il limite di archiviazione',
  'cloudDrive.nodeCreate.storageLimitMin': 'Il limite di archiviazione non può essere inferiore a 1GB',
  'cloudDrive.nodeCreate.storageLimitPlaceholder': 'Inserisci il limite di archiviazione (GB)',
  'cloudDrive.nodeCreate.success': 'Nodo di archiviazione creato con successo',
  'cloudDrive.nodeCreate.failed': 'Errore nella creazione del nodo di archiviazione',
  
  // Modifica nodo
  'cloudDrive.nodeEdit.title': 'Modifica nodo',
  'cloudDrive.nodeEdit.name': 'Nome del nodo',
  'cloudDrive.nodeEdit.nameRequired': 'Inserisci il nome del nodo',
  'cloudDrive.nodeEdit.nameMaxLength': 'Il nome del nodo non può superare i 50 caratteri',
  
  // TextToImage page internationalization
  'create.prompt': 'Prompt',
  'create.prompt.placeholder': 'es.: un gatto cyberpunk che cammina nello spazio, sfondo neon, alto dettaglio...',
  'create.prompt.required': 'Inserisci un prompt',
  'create.prompt.generate': 'IA Genera Prompt',
  'create.prompt.enrich': 'IA Arricchisci Prompt',
  'create.prompt.generate.success': 'Prompt generato con successo!',
  'create.prompt.generate.error': 'Errore nella generazione del prompt, riprova',
  'create.prompt.generate.empty': 'Nessun prompt generato, riprova',
  'create.prompt.restore': 'Ripristina',
  'create.prompt.restore.success': 'Ripristinato al prompt originale',
  'create.prompt.restore.tooltip': 'Ripristina al prompt prima della generazione/arricchimento dell\'IA',
  'create.ratio': 'Proporzioni',
  'create.style': 'Stile Artistico',
  'create.batchSize': 'Dimensione del Batch',
  'create.generate': 'Genera Ora',
  'create.negativePrompt.tooltip': 'Elementi che non vuoi nell\'immagine',
  'create.negativePrompt.placeholder': 'es.: sfocato, bassa qualità, dita deformate...',
  'create.generating': 'Generazione in corso...',
  'create.generating.waiting': 'L\'IA sta creando, attendere prego...',
  'create.result.title': 'Risultati Generati',
  'create.downloadAll': 'Scarica Tutto',
  'create.aspectRatio.1:1': '1:1 (Quadrato)',
  'create.aspectRatio.16:9': '16:9 (Orizzontale)',
  'create.aspectRatio.9:16': '9:16 (Verticale)',
  'create.aspectRatio.21:9': '21:9 (Cinema)',
  'create.aspectRatio.4:3': '4:3 (Classico)',
  'create.style.general': 'Generale',
  'create.style.anime': 'Anime',
  'create.style.realistic': 'Realistico',
  'create.style.3d-render': '3D Render',
  'create.style.cyberpunk': 'Cyberpunk',
  'create.settings.loadFailed': 'Impossibile caricare le impostazioni del tipo di creazione, visualizzazione di tutte le opzioni',
  'create.settings.error': 'Impossibile caricare le impostazioni, visualizzazione di tutte le opzioni',
  'create.noAvailableTabs': 'Nessun tipo di creazione disponibile',
  'create.network.error.title': 'Errore di Connessione di Rete',
  'create.network.error.description': 'Impossibile caricare le impostazioni del tipo di creazione. Si prega di controllare la connessione di rete e aggiornare la pagina',
  'create.network.error.refresh': 'Aggiorna Pagina',
  
  // TextToVideo page internationalization
  'create.prompt.video': 'Descrizione Scena Video (Prompt)',
  'create.prompt.video.placeholder': 'es., Un cane astronauta che balla sulla superficie lunare, 8K, illuminazione cinematografica, surrealismo.',
  'create.prompt.video.required': 'Inserisci una descrizione della scena video',
  'create.generate.video': 'Genera Video Ora',
  'create.video.ratio': 'Rapporto d\'Aspect Video',
  'create.video.camera': 'Movimento della Fotocamera',
  'create.video.duration': 'Durata Video (secondi)',
  'create.video.format': 'Formato di Output',
  'create.cameraMotion.none': 'Nessun Movimento (None)',
  'create.cameraMotion.zoomIn': 'Zoom Avanti (Zoom In)',
  'create.cameraMotion.dollyOut': 'Zoom Indietro (Dolly Out)',
  'create.cameraMotion.panLeft': 'Panoramica Sinistra (Pan Left)',
  'create.cameraMotion.tiltUp': 'Inclinazione Su (Tilt Up)',
  'create.cameraMotion.orbital': '360° Orbitale',
  'create.negativePrompt.video.placeholder': 'es., filigrane, sfarfallio, bassa risoluzione, personaggi sfocati...',
  'create.sora.thinking': 'Sora sta pensando...',
  'create.video.analyzing': 'Analizzando immagine e prompt, l\'IA sta creando...',
  'create.video.info': 'Durata: {duration}s | Rapporto: {ratio}',
  'create.video.preview': 'Anteprima Video',
  'create.video.result': 'Anteprima Video Finale',
  'create.video.empty': 'I risultati generati verranno visualizzati qui',
  'create.download': 'Scarica Video',
  'create.duration.format': '{duration}s',
  'create.duration.4s': '4s',
  'create.duration.8s': '8s',
  'create.duration.15s': '15s',
  'create.estimated.price': 'Stimato: {price}',
  'create.model.select': 'Seleziona Modello',
  'create.model.loading': 'Caricamento modelli...',
  'create.model.loadFailed': 'Impossibile caricare l\'elenco dei modelli',
  'create.model.family.select': 'Seleziona Famiglia di Modelli',
  'create.model.family.select.placeholder': 'Si prega di selezionare una famiglia di modelli',
  'create.model.family.loadFailed': 'Impossibile caricare l\'elenco delle famiglie di modelli',
  'create.style.select.placeholder': 'Si prega di selezionare uno stile artistico (opzionale, per impostazione predefinita usa il modello di famiglia)',
  'create.model.style.loadFailed': 'Impossibile caricare l\'elenco dei modelli di stile',
  'create.model.description': 'Descrizione del Modello',
  'create.model.aspectResolution': 'Risoluzione Proporzione',
  'create.model.fps': 'Frame Rate',
  'create.model.features': 'Funzionalità Supportate',
  'create.model.feature.cameraMotion': 'Movimento della Fotocamera',
  'create.model.feature.img2video': 'Immagine a Video',
  'create.model.feature.videoEdit': 'Modifica Video',
  'create.model.price.perSecond': '/sec',
  'create.model.detail': 'Dettagli',
  'create.history.title': 'Cronologia generazione',
  'create.history.refresh': 'Aggiorna',
  'create.history.empty': 'Nessuna cronologia di generazione',
  'create.history.total': 'Totale {total} record',
  'create.history.status.queued': 'In coda',
  'create.history.status.processing': 'Elaborazione',
  'create.history.status.success': 'Successo',
  'create.history.status.failed': 'Fallito',
  'create.history.status.timeout': 'Timeout',
  'create.history.failed.noImage': 'Generazione fallita',
  'create.history.downloadAll.start': 'Avvio download di {count} immagini',
  'create.history.downloadAll.tooltip': 'Scarica tutte le {count} immagini',
  'create.history.download.tooltip': 'Scarica immagine',
  'create.history.detail.tooltip': 'Visualizza dettagli',
  'create.history.noPrompt': 'Nessun prompt',
  'create.history.deleteConfirm.title': 'Conferma eliminazione',
  'create.history.deleteConfirm.content': 'Sei sicuro di voler eliminare questa attività? Questa azione non può essere annullata.',
  'create.history.deleteSuccess': 'Eliminato con successo',
  'create.history.deleteFailed': 'Eliminazione fallita',
  'create.taskDetail.title': 'Dettagli attività',
  'create.taskDetail.loading': 'Caricamento...',
  'create.taskDetail.loadFailed': 'Errore nel caricamento dei dettagli dell\'attività',
  'create.taskDetail.noData': 'Nessun dato disponibile',
  'create.taskDetail.basicInfo': 'Informazioni di base',
  'create.taskDetail.model': 'Modello',
  'create.taskDetail.taskType': 'Tipo di attività',
  'create.taskDetail.createTime': 'Ora di creazione',
  'create.taskDetail.duration': 'Durata generazione',
  'create.taskDetail.prompt': 'Prompt',
  'create.taskDetail.error': 'Messaggio di errore',
  'create.taskDetail.outputFiles': 'File di output',
  'create.taskDetail.downloadAll': 'Scarica tutto',
  'create.taskDetail.downloadAll.start': 'Avvio download di {count} immagini',
  'create.taskDetail.modelInfo': 'Informazioni modello',
  'create.taskDetail.defaultResolution': 'Risoluzione predefinita',
  'create.taskDetail.maxResolution': 'Risoluzione massima',
  'create.taskDetail.aspectRatios': 'Proporzioni supportate',
  'create.taskDetail.formats': 'Formati supportati',
  'create.taskDetail.prompt.copied': 'Prompt copiato',
  'create.taskDetail.liked': 'Mi piace',
  'create.taskDetail.like': 'Mi piace',
  'create.taskDetail.collected': 'Raccolto',
  'create.taskDetail.collect': 'Raccogli',
  'create.taskDetail.linkCopied': 'Link copiato',
  'create.taskDetail.share': 'Condividi',
  'create.taskDetail.outputs': 'Output',
  'create.taskDetail.preview': 'Anteprima',
  'create.taskDetail.download': 'Scarica',
  'create.taskDetail.generationFailed': 'Generazione fallita',
  'create.taskDetail.generating': 'Generazione in corso...',
  'create.taskDetail.promptLabel': 'Prompt',
  'create.taskDetail.copy': 'Copia',
  'create.taskDetail.executionStats': 'Statistiche di esecuzione',
  'create.taskDetail.creditsCost': 'Costo crediti',
  'create.taskDetail.modelSpecs': 'Specifiche del modello',
  'create.taskDetail.capabilities': 'Funzionalità',
  'create.taskDetail.supportedRatios': 'Proporzioni supportate',
  'create.taskDetail.dataError': 'Errore dati',
  'create.taskDetail.more': 'Altro',
  'create.taskDetail.downloading': 'Download in corso...',
  'create.taskDetail.points': 'punti',
  'create.taskDetail.seconds': 's',
  'create.taskDetail.status.success': 'SUCCESSO',
  'create.taskDetail.status.failed': 'FALLITO',
  'create.taskDetail.status.processing': 'IN ELABORAZIONE',
  'create.taskDetail.status.queued': 'IN CODA',
  'create.taskDetail.status.generating': 'GENERAZIONE',
  'create.taskDetail.durationLabel': 'Durata',
  'create.taskDetail.taskParams': 'Parametri attività',
  'create.taskDetail.aspectRatio': 'Rapporto d\'aspetto',
  'create.taskDetail.inputType': 'Tipo di input',
  'create.taskDetail.modelCode': 'Codice modello',
  'create.taskDetail.regenerate': 'Rigenera',
  'create.taskDetail.feature.developing': 'Funzionalità in sviluppo',
  'create.taskDetail.result': 'Risultato generazione',
  'create.taskDetail.copyPrompt': 'Copia richiesta',
  'create.taskDetail.imageDimensions': 'Dimensioni',
  'create.taskDetail.fileSize': 'Dimensione file',
  'create.taskDetail.loadingImageInfo': 'Caricamento informazioni immagine...',
  'create.history.failed.noVideo': 'Generazione fallita',
  'create.video.generate.cancelled.polling': 'Polling attività annullato',
  'create.video.generate.queued': 'Attività di generazione video inviata, in coda...',
  'create.video.generate.noUrl': 'Generazione video completata, ma URL video non trovato',
  'create.video.status.checkFailed': 'Impossibile verificare lo stato dell\'attività',
  'create.video.generate.processing': 'Attività di generazione video inviata, elaborazione...',
  'create.video.taskQueue': 'Coda attività',
  'create.video.polling': 'Generazione video in corso, attendere...',
  'create.video.ratio.invalid': 'Selezionare un rapporto d\'aspetto video supportato dal modello',
  'create.waitingTask.queue': 'Coda attività',
  'create.waitingTask.empty': 'Nessuna attività in corso',
  'create.waitingTask.generating': 'Generazione...',
  'create.waitingTask.queued': 'In coda',
  'create.waitingTask.cancel': 'Annulla attività',
  // HistorySection nuova internazionalizzazione
  'create.history.copyPrompt': 'Copia prompt',
  'create.history.download': 'Scarica',
  'create.history.delete': 'Elimina',
  'create.history.generating': 'Generazione...',
  'create.history.generationFailed': 'Generazione fallita',
  'create.history.noPreview': 'Nessuna anteprima',
  // ImageToVideo nuova internazionalizzazione
  'create.i2v.fileType.error': 'Seleziona un file immagine',
  'create.i2v.fileSize.error': 'La dimensione del file immagine non può superare 10 MB',
  'create.i2v.imageSize.error': 'L\'altezza dell\'immagine deve essere di almeno {minHeight}px, la dimensione attuale dell\'immagine è {width}x{height}px',
  'create.i2v.fileRead.error': 'Errore nella lettura dell\'immagine',
  'create.i2v.replaceImage': 'Sostituisci immagine',
  'create.i2v.upload.supportedFormats': 'Supporta JPG, PNG, WebP, JFIF',
  'create.i2v.upload.required': 'Carica un\'immagine di riferimento',
  'create.i2v.upload': 'Carica Immagine di Riferimento (Fotogramma Iniziale)',
  'create.i2v.upload.click': 'Clicca o trascina per caricare',
  'create.i2v.prompt.required': 'Inserisci una descrizione di guida al movimento',
  'create.i2v.uploading.image': 'Caricamento immagine nel cloud...',
  'create.i2v.upload.success': 'Immagine caricata con successo',
  'create.i2v.upload.failed': 'Caricamento immagine fallito, riprova',
  'create.i2v.original': 'Originale (fotogramma iniziale)',
  'create.i2v.result': 'Confronto generazione',
  'create.i2v.empty': 'Il confronto tra i risultati generati e l\'immagine originale verrà mostrato qui',
  'create.generate.i2v': 'Inizia generazione video',
  'create.prompt.i2v.placeholder': 'Es: Far camminare la persona nell\'immagine, le foglie sullo sfondo ondeggiano nel vento...',
  'create.prompt.enhance.tooltip': 'Arricchisci il prompt con IA per rendere la descrizione più dettagliata e vivida',
  'create.prompt.enhance': 'Arricchisci con IA',
  'create.prompt.enhance.empty': 'Inserisci prima un prompt base',
  'create.prompt.enhance.success': 'Prompt arricchito con successo!',
  'create.prompt.enhance.empty.result': 'Nessun prompt arricchito generato, riprova',
  'create.prompt.enhance.error': 'Arricchimento prompt fallito, riprova',
  'create.prompt.version.history': 'Cronologia Versioni',
  'create.prompt.version.history.tooltip': 'Visualizza cronologia versioni del prompt',
  // TaskDetailModal nuova internazionalizzazione
  'create.taskDetail.unnamedTask': 'Attività senza nome',
  'create.taskDetail.prompt.title': 'Prompt',
  'create.taskDetail.tokenCost': 'Costo token',
  'create.taskDetail.publish': 'Pubblica nella community',
  'create.taskDetail.selectCover': 'Seleziona copertina',
  'create.taskDetail.selectChannel': 'Seleziona canale',
  'create.taskDetail.selectChallenge': 'Seleziona sfida',
  'create.taskDetail.publishSuccess': 'Pubblicato con successo',
  'create.taskDetail.loadChannelsFailed': 'Caricamento canali fallito',
  'create.taskDetail.loadChallengesFailed': 'Caricamento sfide fallito',
  'create.taskDetail.publishFailed': 'Pubblicazione fallita',
  'create.taskDetail.daysLeft': 'Rimangono {days} giorni',
  // ModelDetailModal nuova internazionalizzazione
  'create.model.capability.t2v': 'T2V (Testo a Video)',
  'create.model.capability.img2video': 'Immagine a Video',
  'create.model.capability.videoEdit': 'Modifica Video',
  'create.model.capability.characterConsistency': 'Coerenza Personaggi',
  'create.model.capability.reference': 'Riferimento',
  'create.model.capability.cameraMotion': 'Movimento Camera',
  'create.model.aspectRatios': 'Proporzioni',
  'create.model.resolution': 'Risoluzione',
  'create.model.resolution.default': 'Predefinito',
  'create.model.resolution.max': 'Massimo',
  'create.model.duration': 'Durata',
  'create.model.formats': 'Formati',
  'create.model.like': 'Mi piace',
  'create.model.liked': 'Piaciuto',
  'create.model.unliked': 'Non più piaciuto',
  'create.model.favorite': 'Preferito',
  'create.model.favorited': 'Aggiunto ai preferiti',
  'create.model.unfavorited': 'Rimosso dai preferiti',
  'create.model.share': 'Condividi',
  'create.model.linkCopied': 'Link copiato',
  'create.model.capabilities': 'Capacità',
  'create.model.free': 'Gratuito',
  'create.model.tokenCost.display': '{count} token',
  // Altre nuove chiavi
  'create.aspectRatio.portrait': 'Verticale',
  'create.aspectRatio.landscape': 'Orizzontale',
  'create.video.ratio.placeholder': 'Seleziona la proporzione video',
  'create.video.format.placeholder': 'Seleziona il formato di output',
  'create.video.style': 'Stile Video',
  'create.video.style.tooltip': 'Seleziona lo stile di generazione video',
  'create.video.style.placeholder': 'Seleziona lo stile video',
  'create.video.quality': 'Qualità Video',
  'create.video.quality.tooltip': 'Seleziona la qualità di generazione video',
  'create.video.quality.placeholder': 'Seleziona la qualità video',
  'create.duration.select.placeholder': 'Seleziona la durata video',
  'create.model.select.placeholder': 'Seleziona prima un modello',
  'video.not.supported': 'Il tuo browser non supporta la riproduzione video.',
  // UnderDevelopment Internazionalizzazione
  'underDevelopment.comingSoon': 'Prossimamente',
  'underDevelopment.title': 'Funzionalità in sviluppo',
  'underDevelopment.subtitle': 'Stiamo lavorando duramente per sviluppare questa funzionalità, restate sintonizzati!',
  'underDevelopment.backHome': 'Torna alla home',
  'underDevelopment.goBack': 'Indietro',
  // UserMenu Internazionalizzazione
  'userMenu.email.notBound': 'Email non collegata',
  'userMenu.status.verified': 'Verificato',
  'userMenu.status.guest': 'Ospite',
  'userMenu.recharge': 'Ricarica ora',
  'userMenu.community': 'Comunità',
  'userMenu.group.account': 'Impostazioni account',
  'userMenu.group.assets': 'Risorse e ordini',
  'userMenu.group.workspace': 'Area di lavoro',
  'userMenu.group.support': 'Supporto',
  'userMenu.item.profile': 'Profilo',
  'userMenu.item.settings': 'Impostazioni',
  'userMenu.item.security': 'Sicurezza',
  'userMenu.item.privacy': 'Privacy',
  'userMenu.item.wallet': 'Il mio portafoglio',
  'userMenu.item.subscription': 'Abbonamento',
  'userMenu.item.orders': 'Cronologia ordini',
  'userMenu.item.works': 'Le mie opere',
  'userMenu.item.notifications': 'Notifiche',
  'userMenu.item.help': 'Centro assistenza',
  'userMenu.item.invite': 'Invita amici',
  'userMenu.item.feedback': 'Feedback',
  'userMenu.item.about': 'Chi siamo',
  'userMenu.level': 'Livello',
  'userMenu.member.vip1': 'Membro base',
  'userMenu.member.vip2': 'Membro argento',
  'userMenu.member.vip3': 'Membro oro',
  'userMenu.member.vip4': 'Membro diamante',
  'userMenu.member.vip5': 'Membro definitivo',
  'userMenu.logout': 'Esci',
  // Recharge Agreement Internazionalizzazione
  'rechargeAgreement.back': 'Indietro',
  'rechargeAgreement.title': 'Accordo di Servizio di Ricarica',
  'rechargeAgreement.lastUpdated': 'Ultimo aggiornamento: ',
  'rechargeAgreement.goRecharge': 'Vai alla Ricarica',
  'rechargeAgreement.section1.title': 'I. Ambito dell\'Accordo',
  'rechargeAgreement.section1.content1': 'Questo accordo è un accordo legale tra te e la piattaforma riguardo ai servizi di ricarica. Prima di utilizzare il servizio di ricarica, leggi attentamente tutto il contenuto di questo accordo. Se non sei d\'accordo con qualsiasi contenuto di questo accordo, o non puoi comprendere con precisione il significato dei termini rilevanti, non eseguire operazioni di ricarica.',
  'rechargeAgreement.section1.content2': 'Facendo clic su "Accetta" o eseguendo operazioni di ricarica, indichi di aver letto, compreso e accettato tutto il contenuto di questo accordo.',
  'rechargeAgreement.section2.title': 'II. Istruzioni di Ricarica',
  'rechargeAgreement.section2.subtitle1': '2.1 Metodi di Ricarica',
  'rechargeAgreement.section2.content1': 'La piattaforma supporta i seguenti metodi di ricarica:',
  'rechargeAgreement.section2.method1': 'Alipay',
  'rechargeAgreement.section2.method2': 'WeChat Pay',
  'rechargeAgreement.section2.method3': 'Carta Bancaria (UnionPay, Visa, MasterCard)',
  'rechargeAgreement.section2.method4': 'Criptovaluta USDT (ERC20/TRC20)',
  'rechargeAgreement.section2.subtitle2': '2.2 Valuta di Ricarica',
  'rechargeAgreement.section2.content2': 'La piattaforma supporta la ricarica nelle seguenti valute: CNY, USD, USDT. Potrebbe esserci una conversione del tasso di cambio tra diverse valute, e il tasso di cambio specifico è soggetto al tasso di cambio in tempo reale al momento della ricarica.',
  'rechargeAgreement.section2.subtitle3': '2.3 Limiti di Ricarica',
  'rechargeAgreement.section2.limit1': 'Ricarica minima singola: 1 yuan (o equivalente in altre valute)',
  'rechargeAgreement.section2.limit2': 'Ricarica massima singola: 50.000 yuan (o equivalente in altre valute)',
  'rechargeAgreement.section2.limit3': 'Limite di ricarica cumulativa giornaliera: 100.000 yuan (o equivalente in altre valute)',
  'rechargeAgreement.section2.note': 'Nota: I limiti di ricarica possono variare a seconda del metodo di pagamento, del livello dell\'account e di altri fattori. Consulta la pagina di ricarica per i dettagli.',
  'rechargeAgreement.section3.title': 'III. Arrivo della Ricarica',
  'rechargeAgreement.section3.subtitle1': '3.1 Tempo di Arrivo',
  'rechargeAgreement.section3.time1': 'Alipay, WeChat Pay: Arrivo in tempo reale',
  'rechargeAgreement.section3.time2': 'Carta Bancaria: 1-3 giorni lavorativi',
  'rechargeAgreement.section3.time3': 'USDT: Secondo il tempo di conferma della blockchain, generalmente 10-30 minuti',
  'rechargeAgreement.section3.subtitle2': '3.2 Gestione delle Eccezioni',
  'rechargeAgreement.section3.content1': 'Se la ricarica non arriva in tempo, conserva la ricevuta di pagamento e contatta immediatamente il servizio clienti. La piattaforma elaborerà il tuo problema di ricarica il prima possibile dopo la verifica.',
  'rechargeAgreement.section4.title': 'IV. Politica di Rimborso',
  'rechargeAgreement.section4.important': 'Importante: Dopo una ricarica riuscita, il saldo del conto non supporta il rimborso diretto. Il saldo può essere utilizzato solo per il consumo di servizi all\'interno della piattaforma.',
  'rechargeAgreement.section4.subtitle1': '4.1 Condizioni di Rimborso',
  'rechargeAgreement.section4.content1': 'Puoi richiedere un rimborso nei seguenti casi:',
  'rechargeAgreement.section4.refund1': 'Ricarica duplicata dovuta a guasti del sistema della piattaforma',
  'rechargeAgreement.section4.refund2': 'Servizio non disponibile a causa della piattaforma, e il saldo del conto non è stato consumato',
  'rechargeAgreement.section4.refund3': 'Altre circostanze speciali approvate dalla piattaforma dopo la revisione',
  'rechargeAgreement.section4.subtitle2': '4.2 Processo di Rimborso',
  'rechargeAgreement.section4.process1': 'Invia richiesta di rimborso e spiega il motivo',
  'rechargeAgreement.section4.process2': 'Revisione della piattaforma (solitamente 3-7 giorni lavorativi)',
  'rechargeAgreement.section4.process3': 'Dopo l\'approvazione, il rimborso verrà restituito al tuo account di pagamento',
  'rechargeAgreement.section5.title': 'V. Sicurezza dell\'Account',
  'rechargeAgreement.section5.content1': 'Sei responsabile della conservazione adeguata delle informazioni del tuo account e della password. La piattaforma non è responsabile delle perdite causate dal furto dell\'account o dalla fuga della password dovute alle tue ragioni.',
  'rechargeAgreement.section5.content2': 'Se rilevi anomalie dell\'account, contatta immediatamente il servizio clienti e modifica la password. La piattaforma ti aiuterà a gestire problemi correlati.',
  'rechargeAgreement.section6.title': 'VI. Dichiarazione di Non Responsabilità',
  'rechargeAgreement.section6.disclaimer1': 'La piattaforma non è responsabile delle interruzioni del servizio causate da forza maggiore (come disastri naturali, guerra, azioni governative, ecc.)',
  'rechargeAgreement.section6.disclaimer2': 'Per problemi di ricarica causati da guasti delle piattaforme di pagamento di terze parti, la piattaforma aiuterà nella gestione ma non assume responsabilità diretta',
  'rechargeAgreement.section6.disclaimer3': 'Le perdite causate dalle violazioni dell\'utente di questo accordo o leggi e regolamenti pertinenti saranno sostenute dall\'utente stesso',
  'rechargeAgreement.section7.title': 'VII. Modifica dell\'Accordo',
  'rechargeAgreement.section7.content1': 'La piattaforma ha il diritto di modificare questo accordo secondo le esigenze di sviluppo commerciale. Dopo la modifica dell\'accordo, sarà annunciato in una posizione prominente sulla piattaforma. Se continui a utilizzare il servizio di ricarica, è considerato come accettazione dell\'accordo modificato.',
  'rechargeAgreement.section8.title': 'VIII. Informazioni di Contatto',
  'rechargeAgreement.section8.content1': 'Se hai domande su questo accordo, o devi richiedere un rimborso o gestire problemi di ricarica, contattaci tramite i seguenti metodi:',
  'rechargeAgreement.section8.contact1': 'Email del Servizio Clienti: support@example.com',
  'rechargeAgreement.section8.contact2': 'Servizio Clienti Online: Giorni lavorativi 9:00-18:00',
  'rechargeAgreement.section8.contact3': 'Centro Assistenza: Visualizza FAQ',
  // Internazionalizzazione profilo
  'profile.editProfile': 'Modifica Profilo',
  'profile.creditScore': 'Punteggio di Credito',
  'profile.level': 'Livello',
  'profile.balance': 'Saldo',
  'profile.tab.basic': 'Informazioni di Base',
  'profile.tab.account': 'Patrimonio Account',
  'profile.section.personal': 'Informazioni Personali',
  'profile.section.contact': 'Contatto',
  'profile.section.wallet': 'Portafoglio USDT',
  'profile.label.username': 'Nome Utente',
  'profile.label.realName': 'Nome Reale',
  'profile.label.accountStatus': 'Stato Account',
  'profile.label.phone': 'Numero di Telefono',
  'profile.label.email': 'Email',
  'profile.label.registerTime': 'Orario di Registrazione',
  'profile.label.availableBalance': 'Saldo Disponibile',
  'profile.label.frozenAmount': 'Importo Congelato',
  'profile.value.notVerified': 'Non Verificato',
  'profile.value.notBound': 'Non Vincolato',
  'profile.value.noAddress': 'Nessun Indirizzo TRC20',
  'profile.value.noDescription': 'Questa persona è pigra e non ha scritto nulla',
  'profile.status.normal': 'Normale',
  'profile.status.disabled': 'Disabilitato',
  'profile.tooltip.verified': 'Verificato',
  'profile.tooltip.unverified': 'Verifica Ora',
  'profile.banner.construction': 'Questa pagina è in costruzione...',
  'profile.modal.title': 'Modifica Profilo',
  'profile.modal.cancel': 'Annulla',
  'profile.modal.save': 'Salva Modifiche',
  'profile.modal.avatarSection': 'Impostazioni Avatar',
  'profile.modal.basicSection': 'Informazioni di Base',
  'profile.modal.contactSection': 'Informazioni di Contatto',
  'profile.modal.changeAvatar': 'Cambia Avatar',
  'profile.modal.avatarHint': 'Supporta formati JPG, PNG, massimo 2MB',
  'profile.modal.nickname': 'Nickname',
  'profile.modal.nicknamePlaceholder': 'Inserisci il tuo nickname',
  'profile.modal.description': 'Biografia',
  'profile.modal.descriptionPlaceholder': 'Presentati in una frase...',
  'profile.modal.phone': 'Telefono',
  'profile.modal.email': 'Email',
  'profile.message.avatarSizeLimit': 'La dimensione dell\'immagine non può superare 2MB',
  'profile.message.avatarUploadSuccess': 'Avatar caricato con successo',
  'profile.message.saveSuccess': 'Salvato con successo',
  'profile.message.saveFailed': 'Salvataggio fallito',
  'profile.message.uploadAvatarFailed': 'Caricamento avatar fallito',
  'profile.message.operationFailed': 'Operazione fallita',
  'privacyPreferences.title': 'Preferenze sulla Privacy',
  'privacyPreferences.description': 'Gestisci le tue impostazioni sulla privacy e controlla come raccogliamo e utilizziamo i tuoi dati',
  'privacyPreferences.back': 'Indietro',
  'privacyPreferences.save': 'Salva Impostazioni',
  'privacyPreferences.saveSuccess': 'Preferenze sulla privacy salvate con successo',
  'privacyPreferences.saveError': 'Salvataggio fallito, riprova più tardi',
  'privacyPreferences.required': 'Richiesto',
  'privacyPreferences.info': 'Le tue preferenze sulla privacy verranno salvate localmente e applicate automaticamente alla tua prossima visita. Accedi per sincronizzare le impostazioni con il cloud.',
  'privacyPreferences.info.loggedIn': 'Le tue preferenze sulla privacy verranno salvate nel tuo account e sincronizzate su tutti i dispositivi. Puoi tornare a questa pagina per modificare queste impostazioni in qualsiasi momento.',
  'cookieBanner.message': 'Utilizziamo cookie e archiviazione locale per accesso, tema e funzionalità di base. Continuando accetti la nostra privacy policy.',
  'cookieBanner.acceptAll': 'Accetta tutto',
  'cookieBanner.essentialOnly': 'Solo essenziali',
  'cookieBanner.settings': 'Preferenze',
  'privacyPreferences.cookies.title': 'Preferenze sui Cookie',
  'privacyPreferences.cookies.description': 'I cookie ci aiutano a fornire una migliore esperienza di servizio. Puoi scegliere di accettare o rifiutare determinati tipi di cookie.',
  'privacyPreferences.cookies.essential': 'Cookie Essenziali',
  'privacyPreferences.cookies.essential.desc': 'Questi cookie sono necessari per il corretto funzionamento del sito web e non possono essere disattivati. Sono generalmente utilizzati per sicurezza, accesso e funzionalità di base.',
  'privacyPreferences.cookies.functional': 'Cookie Funzionali',
  'privacyPreferences.cookies.functional.desc': 'Questi cookie consentono al sito web di ricordare le tue scelte e fornire funzionalità migliorate ed esperienze personalizzate.',
  'privacyPreferences.cookies.analytics': 'Cookie di Analisi',
  'privacyPreferences.cookies.analytics.desc': 'Questi cookie ci aiutano a capire come i visitatori utilizzano il sito web in modo da poter migliorare i nostri servizi.',
  'privacyPreferences.cookies.marketing': 'Cookie di Marketing',
  'privacyPreferences.cookies.marketing.desc': 'Questi cookie vengono utilizzati per tracciare la tua attività di navigazione per mostrarti annunci e contenuti pertinenti.',
  'privacyPreferences.data.title': 'Preferenze sulla Raccolta di Dati',
  'privacyPreferences.data.description': 'Controlla come raccogliamo e utilizziamo i tuoi dati per migliorare l\'esperienza del servizio.',
  'privacyPreferences.data.collection': 'Raccolta di Dati',
  'privacyPreferences.data.collection.desc': 'Consentici di raccogliere i dati di utilizzo necessari per fornire e migliorare i servizi.',
  'privacyPreferences.data.analytics': 'Analisi dei Dati',
  'privacyPreferences.data.analytics.desc': 'Consentici di analizzare i tuoi modelli di utilizzo per ottimizzare le prestazioni del servizio e l\'esperienza utente.',
  'privacyPreferences.data.personalization': 'Personalizzazione',
  'privacyPreferences.data.personalization.desc': 'Consentici di fornire contenuti e raccomandazioni personalizzati basati sulle tue preferenze e abitudini di utilizzo.',
  'privacyPreferences.marketing.title': 'Preferenze di Marketing',
  'privacyPreferences.marketing.description': 'Scegli i tipi di comunicazioni di marketing che desideri ricevere.',
  'privacyPreferences.marketing.emails': 'Email di Marketing',
  'privacyPreferences.marketing.emails.desc': 'Ricevi notifiche via email su aggiornamenti di prodotti, promozioni e offerte speciali.',
  'privacyPreferences.marketing.sms': 'SMS di Marketing',
  'privacyPreferences.marketing.sms.desc': 'Ricevi notifiche SMS su aggiornamenti importanti e promozioni.',
  'privacyPreferences.marketing.push': 'Notifiche Push',
  'privacyPreferences.marketing.push.desc': 'Ricevi notifiche push del browser, inclusi aggiornamenti di prodotti e messaggi importanti.',
  'privacyPreferences.thirdParty.title': 'Condivisione Dati con Terze Parti',
  'privacyPreferences.thirdParty.description': 'Controlla se consentire la condivisione dei tuoi dati con fornitori di servizi di terze parti.',
  'privacyPreferences.thirdParty.sharing': 'Condivisione Dati con Terze Parti',
  'privacyPreferences.thirdParty.sharing.desc': 'Consentici di condividere dati di utilizzo anonimi con fornitori di servizi di terze parti affidabili per migliorare i servizi.',
  
  // Politica sulla Privacy
  'privacyPolicy.title': 'Politica sulla Privacy',
  'privacyPolicy.lastUpdated': 'Ultimo aggiornamento: {date}',
  'privacyPolicy.intro1': 'Questa Politica sulla Privacy descrive come la piattaforma AIMATEX (di seguito "noi" o "questa piattaforma") raccoglie, utilizza, archivia e protegge le tue informazioni personali quando utilizzi i nostri servizi, nonché i tuoi diritti sulla privacy. Attribuiamo grande importanza alla protezione della tua privacy. Si prega di leggere attentamente questa Politica sulla Privacy.',
  'privacyPolicy.intro2': 'Utilizzando i nostri servizi, accetti questa Politica sulla Privacy. Se non sei d\'accordo con qualsiasi parte di questa Politica sulla Privacy, non utilizzare i nostri servizi.',
  'privacyPolicy.section1.title': 'I. Informazioni che Raccogliamo',
  'privacyPolicy.section1.1.title': '1.1 Informazioni che Fornisci',
  'privacyPolicy.section1.1.intro': 'Quando utilizzi questo servizio, potrebbe essere necessario fornire le seguenti informazioni:',
  'privacyPolicy.section1.1.item1.label': 'Informazioni Account',
  'privacyPolicy.section1.1.item1.desc': 'Nome utente, indirizzo email, password, numero di telefono, ecc.',
  'privacyPolicy.section1.1.item2.label': 'Informazioni Profilo',
  'privacyPolicy.section1.1.item2.desc': 'Avatar, soprannome, biografia, ecc. (opzionale)',
  'privacyPolicy.section1.1.item3.label': 'Informazioni di Pagamento',
  'privacyPolicy.section1.1.item3.desc': 'Metodi di pagamento, indirizzo di fatturazione, ecc. (per l\'elaborazione dei pagamenti)',
  'privacyPolicy.section1.1.item4.label': 'Contenuto Generato',
  'privacyPolicy.section1.1.item4.desc': 'Prompt di testo, immagini di riferimento, video, musica, immagini, modelli 3D generati, ecc. che carichi',
  'privacyPolicy.section1.2.title': '1.2 Informazioni Raccolte Automaticamente',
  'privacyPolicy.section1.2.intro': 'Quando utilizzi questo servizio, possiamo raccogliere automaticamente le seguenti informazioni:',
  'privacyPolicy.section1.2.item1.label': 'Informazioni Dispositivo',
  'privacyPolicy.section1.2.item1.desc': 'Tipo di dispositivo, sistema operativo, tipo e versione del browser, identificatori del dispositivo, ecc.',
  'privacyPolicy.section1.2.item2.label': 'Dati di Utilizzo',
  'privacyPolicy.section1.2.item2.desc': 'Ora di accesso, pagine visitate, funzionalità utilizzate, registri delle operazioni, ecc.',
  'privacyPolicy.section1.2.item3.label': 'Informazioni di Rete',
  'privacyPolicy.section1.2.item3.desc': 'Indirizzo IP, tipo di rete, operatore di rete, ecc.',
  'privacyPolicy.section1.2.item4.label': 'Informazioni di Registro',
  'privacyPolicy.section1.2.item4.desc': 'Registri degli errori, dati sulle prestazioni, ecc.',
  'privacyPolicy.section1.3.title': '1.3 Cookie e Tecnologie Simili',
  'privacyPolicy.section1.3.intro': 'Utilizziamo cookie e tecnologie simili per:',
  'privacyPolicy.section1.3.item1': 'Mantenere il tuo stato di accesso',
  'privacyPolicy.section1.3.item2': 'Ricordare le tue preferenze (come lingua, tema, ecc.)',
  'privacyPolicy.section1.3.item3': 'Analizzare l\'utilizzo del servizio per migliorare la qualità del servizio',
  'privacyPolicy.section1.3.item4': 'Fornire un\'esperienza personalizzata',
  'privacyPolicy.section1.3.note': 'Puoi rifiutare i cookie tramite le impostazioni del browser, ma ciò potrebbe influire sull\'utilizzo di alcune funzionalità.',
  'privacyPolicy.section2.title': 'II. Scopo dell\'Utilizzo delle Informazioni',
  'privacyPolicy.section2.intro': 'Raccogliamo e utilizziamo le tue informazioni per i seguenti scopi:',
  'privacyPolicy.section2.item1.label': 'Fornire Servizi',
  'privacyPolicy.section2.item1.desc': 'Elaborare le tue richieste di generazione contenuti (video, musica, immagini, modelli 3D, ecc.), gestire il tuo account e le tue opere, ecc.',
  'privacyPolicy.section2.item2.label': 'Migliorare i Servizi',
  'privacyPolicy.section2.item2.desc': 'Analizzare l\'utilizzo, ottimizzare le prestazioni del servizio e l\'esperienza utente',
  'privacyPolicy.section2.item3.label': 'Gestione Account',
  'privacyPolicy.section2.item3.desc': 'Verificare l\'identità, elaborare i pagamenti, inviare notifiche, ecc.',
  'privacyPolicy.section2.item4.label': 'Sicurezza',
  'privacyPolicy.section2.item4.desc': 'Rilevare e prevenire frodi, abusi, minacce alla sicurezza, ecc.',
  'privacyPolicy.section2.item5.label': 'Supporto Clienti',
  'privacyPolicy.section2.item5.desc': 'Rispondere alle tue richieste, gestire reclami e feedback, ecc.',
  'privacyPolicy.section2.item6.label': 'Conformità Legale',
  'privacyPolicy.section2.item6.desc': 'Rispettare i requisiti legali, cooperare con le indagini delle forze dell\'ordine, ecc.',
  'privacyPolicy.section3.title': 'III. Condivisione e Divulgazione delle Informazioni',
  'privacyPolicy.section3.1.title': '3.1 Non Vendiamo le Tue Informazioni Personali',
  'privacyPolicy.section3.1.content': 'Non vendiamo, affittiamo né scambiamo le tue informazioni personali con terze parti.',
  'privacyPolicy.section3.2.title': '3.2 Fornitori di Servizi',
  'privacyPolicy.section3.2.intro': 'Possiamo condividere informazioni con i seguenti tipi di fornitori di servizi:',
  'privacyPolicy.section3.2.item1.label': 'Fornitori di Servizi Cloud',
  'privacyPolicy.section3.2.item1.desc': 'Per l\'archiviazione e l\'elaborazione dei dati',
  'privacyPolicy.section3.2.item2.label': 'Fornitori di Servizi di Pagamento',
  'privacyPolicy.section3.2.item2.desc': 'Per l\'elaborazione delle transazioni di pagamento',
  'privacyPolicy.section3.2.item3.label': 'Fornitori di Servizi di Analisi',
  'privacyPolicy.section3.2.item3.desc': 'Per analizzare l\'utilizzo del servizio',
  'privacyPolicy.section3.2.item4.label': 'Fornitori di Servizi di Supporto Clienti',
  'privacyPolicy.section3.2.item4.desc': 'Per fornire supporto clienti',
  'privacyPolicy.section3.2.note': 'Questi fornitori di servizi possono utilizzare le informazioni solo per fornirci servizi e non per altri scopi.',
  'privacyPolicy.section3.3.title': '3.3 Requisiti Legali',
  'privacyPolicy.section3.3.intro': 'Possiamo divulgare le tue informazioni nelle seguenti circostanze:',
  'privacyPolicy.section3.3.item1': 'Rispettare leggi, regolamenti, ordini del tribunale o requisiti governativi',
  'privacyPolicy.section3.3.item2': 'Proteggere i nostri diritti, proprietà o sicurezza',
  'privacyPolicy.section3.3.item3': 'Prevenire o indagare su possibili attività illegali',
  'privacyPolicy.section3.3.item4': 'Proteggere la sicurezza degli utenti o del pubblico',
  'privacyPolicy.section3.4.title': '3.4 Trasferimento Aziendale',
  'privacyPolicy.section3.4.content': 'In caso di fusione, acquisizione o trasferimento di asset, le tue informazioni potrebbero essere trasferite. Ti informeremo prima del trasferimento.',
  'privacyPolicy.section4.title': 'IV. Archiviazione e Sicurezza delle Informazioni',
  'privacyPolicy.section4.1.title': '4.1 Posizione di Archiviazione',
  'privacyPolicy.section4.1.content': 'Le tue informazioni possono essere archiviate su server situati all\'interno o all\'esterno della Repubblica Popolare Cinese. Adotteremo misure appropriate per garantire la sicurezza delle informazioni.',
  'privacyPolicy.section4.2.title': '4.2 Periodo di Conservazione',
  'privacyPolicy.section4.2.intro': 'Conserviamo le tue informazioni solo per il periodo necessario:',
  'privacyPolicy.section4.2.item1': 'Informazioni account: durante la durata del tuo account e per un periodo dopo la cancellazione',
  'privacyPolicy.section4.2.item2': 'Contenuto generato: conservato secondo le tue impostazioni o i requisiti legali',
  'privacyPolicy.section4.2.item3': 'Dati di utilizzo: generalmente conservati per un periodo più breve per analisi e miglioramento del servizio',
  'privacyPolicy.section4.3.title': '4.3 Misure di Sicurezza',
  'privacyPolicy.section4.3.intro': 'Adottiamo le seguenti misure di sicurezza per proteggere le tue informazioni:',
  'privacyPolicy.section4.3.item1': 'Trasmissione e archiviazione crittografate',
  'privacyPolicy.section4.3.item2': 'Controllo degli accessi e autenticazione',
  'privacyPolicy.section4.3.item3': 'Audit di sicurezza regolari e scansioni delle vulnerabilità',
  'privacyPolicy.section4.3.item4': 'Formazione del personale e accordi di riservatezza',
  'privacyPolicy.section4.3.note': 'Si prega di notare che nessuna misura di sicurezza è sicura al 100%. Non possiamo garantire la sicurezza assoluta delle informazioni.',
  'privacyPolicy.section5.title': 'V. I Tuoi Diritti',
  'privacyPolicy.section5.intro': 'Secondo le leggi e i regolamenti applicabili, hai i seguenti diritti:',
  'privacyPolicy.section5.item1.label': 'Diritto di Accesso',
  'privacyPolicy.section5.item1.desc': 'Visualizzare le tue informazioni personali che possediamo',
  'privacyPolicy.section5.item2.label': 'Diritto di Rettifica',
  'privacyPolicy.section5.item2.desc': 'Correggere informazioni inaccurate o incomplete',
  'privacyPolicy.section5.item3.label': 'Diritto di Cancellazione',
  'privacyPolicy.section5.item3.desc': 'Richiedere la cancellazione delle tue informazioni personali (eccetto quando la legge richiede la conservazione)',
  'privacyPolicy.section5.item4.label': 'Diritto di Ritirare il Consenso',
  'privacyPolicy.section5.item4.desc': 'Ritirare il tuo consenso all\'elaborazione delle informazioni',
  'privacyPolicy.section5.item5.label': 'Diritto alla Portabilità dei Dati',
  'privacyPolicy.section5.item5.desc': 'Ottenere una copia delle tue informazioni personali',
  'privacyPolicy.section5.item6.label': 'Diritto di Opposizione',
  'privacyPolicy.section5.item6.desc': 'Opporsi a determinate attività di elaborazione delle informazioni',
  'privacyPolicy.section5.note': 'Per esercitare i diritti sopra indicati, contattaci tramite le informazioni di contatto alla fine di questa Politica sulla Privacy.',
  'privacyPolicy.section6.title': 'VI. Protezione dei Minori',
  'privacyPolicy.section6.content1': 'Questo servizio è principalmente destinato a utenti di età superiore ai 18 anni. Se hai meno di 18 anni, utilizza questo servizio con il consenso e sotto la supervisione del tuo tutore.',
  'privacyPolicy.section6.content2': 'Se scopriamo di aver raccolto informazioni personali di utenti di età inferiore ai 18 anni senza il consenso del tutore, elimineremo le informazioni pertinenti il prima possibile.',
  'privacyPolicy.section7.title': 'VII. Link di Terze Parti',
  'privacyPolicy.section7.content': 'Questo servizio può contenere link a siti web di terze parti. Non siamo responsabili delle pratiche sulla privacy di questi siti web di terze parti. Quando visiti questi siti, consulta le loro politiche sulla privacy.',
  'privacyPolicy.section8.title': 'VIII. Modifiche alla Politica sulla Privacy',
  'privacyPolicy.section8.content1': 'Possiamo aggiornare questa Politica sulla Privacy di tanto in tanto. Le modifiche importanti ti saranno notificate almeno 30 giorni prima che entrino in vigore. L\'uso continuato del servizio indica la tua accettazione della Politica sulla Privacy aggiornata.',
  'privacyPolicy.section8.content2': 'Aggiorneremo la data "Ultimo aggiornamento" nella parte superiore di questa pagina e ti informeremo delle modifiche importanti tramite email o notifiche nell\'app.',
  'privacyPolicy.section9.title': 'IX. Contattaci',
  'privacyPolicy.section9.intro': 'Se hai domande, commenti o reclami su questa Politica sulla Privacy, contattaci tramite i seguenti metodi:',
  'privacyPolicy.section9.email': 'Email: {email}',
  'privacyPolicy.section9.hours': 'Orari di assistenza clienti: giorni feriali 9:00-18:00',
  'privacyPolicy.section9.response': 'Risponderemo alla tua richiesta entro un tempo ragionevole.',
  
  // Termini di Servizio
  'termsOfService.title': 'Termini di Servizio',
  'termsOfService.lastUpdated': 'Ultimo aggiornamento: {date}',
  'termsOfService.intro': 'Prima di utilizzare i nostri servizi, leggi attentamente questi Termini di Servizio. Accedendo o utilizzando la piattaforma AIMATEX (di seguito "questa piattaforma" o "servizio"), accetti di essere vincolato da questi Termini di Servizio. Se non sei d\'accordo con qualsiasi parte di questi Termini di Servizio, non utilizzare i nostri servizi.',
  'termsOfService.section1.title': 'I. Definizioni e Interpretazione',
  'termsOfService.section1.1.title': '1.1 Definizioni',
  'termsOfService.section1.1.intro': 'In questi Termini di Servizio, salvo indicazione contraria del contesto, i seguenti termini hanno i seguenti significati:',
  'termsOfService.section1.1.item1.label': '"Piattaforma" o "Questa Piattaforma"',
  'termsOfService.section1.1.item1.desc': 'Si riferisce alla piattaforma di servizio di generazione video AIMATEX, inclusi ma non limitati a siti web, applicazioni mobili e servizi correlati.',
  'termsOfService.section1.1.item2.label': '"Noi", "Nostro", "Azienda"',
  'termsOfService.section1.1.item2.desc': 'Si riferisce all\'operatore della piattaforma AIMATEX, ovvero ProTX Team.',
  'termsOfService.section1.1.item3.label': '"Tu", "Utente"',
  'termsOfService.section1.1.item3.desc': 'Si riferisce a qualsiasi individuo, azienda o altra entità legale che accede o utilizza questo servizio.',
  'termsOfService.section1.1.item4.label': '"Servizio"',
  'termsOfService.section1.1.item4.desc': 'Si riferisce a tutte le funzionalità e servizi forniti da questa piattaforma, inclusi ma non limitati a generazione di video, musica, immagini, modelli 3D IA e altri contenuti, selezione modelli, gestione opere, gestione account utente, ecc.',
  'termsOfService.section1.1.item5.label': '"Contenuto"',
  'termsOfService.section1.1.item5.desc': 'Si riferisce a qualsiasi testo, immagine, video, audio e altri materiali caricati, generati, creati o condivisi dagli utenti tramite questa piattaforma.',
  'termsOfService.section1.1.item6.label': '"Contenuto Generato"',
  'termsOfService.section1.1.item6.desc': 'Si riferisce a video, musica, immagini, modelli 3D e altre opere generate dagli utenti utilizzando i modelli IA di questa piattaforma.',
  'termsOfService.section1.1.item7.label': '"Account"',
  'termsOfService.section1.1.item7.desc': 'Si riferisce all\'account utente registrato dagli utenti su questa piattaforma.',
  'termsOfService.section2.title': 'II. Descrizione del Servizio',
  'termsOfService.section2.1.title': '2.1 Contenuto del Servizio',
  'termsOfService.section2.1.intro': 'Questa piattaforma fornisce servizi completi di generazione contenuti IA, inclusi ma non limitati a:',
  'termsOfService.section2.1.item1': 'Generazione da testo a media (video, musica, immagini, modelli 3D, ecc.) (Text-to-Media)',
  'termsOfService.section2.1.item2': 'Generazione da immagine a media (video, modelli 3D, ecc.) (Image-to-Media)',
  'termsOfService.section2.1.item3': 'Gestione e visualizzazione di varie opere generate',
  'termsOfService.section2.1.item4': 'Selezione e gestione modelli',
  'termsOfService.section2.1.item5': 'Account utente e centro personale',
  'termsOfService.section2.1.item6': 'Servizi di abbonamento e pagamento',
  'termsOfService.section2.2.title': '2.2 Modifiche al Servizio',
  'termsOfService.section2.2.content': 'Ci riserviamo il diritto di modificare, sospendere o terminare parte o tutto il servizio in qualsiasi momento senza preavviso. Non siamo responsabili di eventuali perdite causate da modifiche al servizio.',
  'termsOfService.section3.title': 'III. Account Utente',
  'termsOfService.section3.1.title': '3.1 Registrazione Account',
  'termsOfService.section3.1.intro': 'L\'utilizzo di questo servizio richiede la registrazione di un account. Al momento della registrazione, accetti di:',
  'termsOfService.section3.1.item1': 'Fornire informazioni di registrazione vere, accurate e complete',
  'termsOfService.section3.1.item2': 'Aggiornare le informazioni di registrazione in modo tempestivo per mantenerle vere, accurate e complete',
  'termsOfService.section3.1.item3': 'Essere responsabile di tutte le attività sotto il tuo account',
  'termsOfService.section3.1.item4': 'Mantenere la password del tuo account sicura e non trasferire, vendere o prestare il tuo account ad altri',
  'termsOfService.section3.2.title': '3.2 Restrizione di Età',
  'termsOfService.section3.2.content': 'Devi avere almeno 18 anni per utilizzare questo servizio. Se hai meno di 18 anni, utilizza questo servizio con il consenso e sotto la supervisione del tuo tutore.',
  'termsOfService.section3.3.title': '3.3 Sicurezza dell\'Account',
  'termsOfService.section3.3.content': 'Sei responsabile di mantenere la sicurezza del tuo account. Se scopri che il tuo account è stato compromesso o esiste una vulnerabilità di sicurezza, informaci immediatamente. Non siamo responsabili delle perdite causate dal tuo mancato proteggere adeguatamente le informazioni del tuo account.',
  'termsOfService.section4.title': 'IV. Regole di Utilizzo',
  'termsOfService.section4.1.title': '4.1 Attività Proibite',
  'termsOfService.section4.1.intro': 'Quando utilizzi questo servizio, non devi:',
  'termsOfService.section4.1.item1': 'Generare, caricare o condividere contenuti illegali, dannosi, minacciosi, offensivi, molesti, diffamatori, volgari, osceni, che violano la privacy o i diritti di proprietà intellettuale di altri',
  'termsOfService.section4.1.item2': 'Generare o diffondere informazioni false, contenuti fuorvianti o contenuti dannosi',
  'termsOfService.section4.1.item3': 'Utilizzare questo servizio per frodi commerciali, riciclaggio di denaro o altre attività illegali',
  'termsOfService.section4.1.item4': 'Interferire o distruggere il funzionamento normale di questa piattaforma, inclusi ma non limitati all\'utilizzo di strumenti automatizzati, crawler, virus, ecc.',
  'termsOfService.section4.1.item5': 'Accedere senza autorizzazione a qualsiasi sistema, dati o account di questa piattaforma',
  'termsOfService.section4.1.item6': 'Copiare, modificare, distribuire, vendere o affittare qualsiasi parte di questa piattaforma',
  'termsOfService.section4.1.item7': 'Eseguire reverse engineering, decompilare o disassemblare qualsiasi software di questa piattaforma',
  'termsOfService.section4.2.title': '4.2 Responsabilità del Contenuto',
  'termsOfService.section4.2.content': 'Sei completamente responsabile di tutto il contenuto generato, caricato o condiviso tramite questa piattaforma. Non pre-revisioniamo il contenuto generato dagli utenti, ma ci riserviamo il diritto di eliminare contenuti che violano le regole in qualsiasi momento.',
  'termsOfService.section5.title': 'V. Proprietà Intellettuale',
  'termsOfService.section5.1.title': '5.1 Proprietà Intellettuale della Piattaforma',
  'termsOfService.section5.1.content': 'Tutti i diritti di proprietà intellettuale di questa piattaforma, inclusi ma non limitati a marchi, brevetti, diritti d\'autore, segreti commerciali, ecc., appartengono a noi o ai titolari dei diritti corrispondenti. Non puoi utilizzarli senza autorizzazione.',
  'termsOfService.section5.2.title': '5.2 Contenuto Generato dall\'Utente',
  'termsOfService.section5.2.content': 'I diritti di proprietà intellettuale del contenuto che generi tramite questa piattaforma ti appartengono. Tuttavia, ci concedi un diritto non esclusivo, globale, gratuito e sublicenziabile di utilizzare, visualizzare e distribuire il tuo contenuto per fornire e migliorare i servizi.',
  'termsOfService.section5.3.title': '5.3 Modelli IA',
  'termsOfService.section5.3.content': 'I diritti di proprietà intellettuale dei modelli IA (inclusi i modelli Sora) utilizzati da questa piattaforma appartengono ai loro sviluppatori. Non puoi copiare, modificare o distribuire questi modelli.',
  'termsOfService.section6.title': 'VI. Servizi a Pagamento',
  'termsOfService.section6.1.title': '6.1 Modelli di Pagamento',
  'termsOfService.section6.1.content': 'Questa piattaforma offre due modelli di pagamento: abbonamento e pagamento per utilizzo. I prezzi specifici e i metodi di fatturazione sono soggetti agli annunci della piattaforma.',
  'termsOfService.section6.2.title': '6.2 Pagamento',
  'termsOfService.section6.2.content': 'Accetti di pagare le tariffe del servizio secondo i prezzi annunciati dalla piattaforma. Tutte le tariffe sono calcolate in RMB o altre valute supportate dalla piattaforma. Dopo un pagamento riuscito, le tariffe non sono rimborsabili, salvo disposizione contraria della legge o altri impegni da parte nostra.',
  'termsOfService.section6.3.title': '6.3 Politica di Rimborso',
  'termsOfService.section6.3.content': 'Salvo disposizione contraria della legge o altri impegni da parte nostra, le tariffe pagate non sono rimborsabili. Se il servizio non può essere utilizzato normalmente a causa di problemi della piattaforma, forniremo rimborsi o compensazioni secondo la situazione reale.',
  'termsOfService.section7.title': 'VII. Disponibilità del Servizio',
  'termsOfService.section7.1.title': '7.1 Interruzione del Servizio',
  'termsOfService.section7.1.intro': 'Non siamo responsabili delle interruzioni del servizio causate dai seguenti motivi:',
  'termsOfService.section7.1.item1': 'Manutenzione, aggiornamento o guasto del sistema',
  'termsOfService.section7.1.item2': 'Fattori di forza maggiore (come disastri naturali, guerre, scioperi, ecc.)',
  'termsOfService.section7.1.item3': 'Problemi con fornitori di servizi di terze parti',
  'termsOfService.section7.1.item4': 'Guasti di rete o problemi con dispositivi utente',
  'termsOfService.section7.2.title': '7.2 Garanzia del Servizio',
  'termsOfService.section7.2.content': 'Ci sforziamo di garantire la stabilità e la disponibilità del servizio, ma non garantiamo che il servizio non sarà interrotto, senza errori o completamente sicuro. Il servizio è fornito "così com\'è" e "come disponibile" senza garanzie espresse o implicite.',
  'termsOfService.section8.title': 'VIII. Protezione della Privacy',
  'termsOfService.section8.content': 'Attribuiamo grande importanza alla protezione della tua privacy. Per informazioni su come raccogliamo, utilizziamo e proteggiamo le tue informazioni personali, consulta la nostra Politica sulla Privacy. L\'utilizzo di questo servizio indica il tuo accordo con la nostra Politica sulla Privacy.',
  'termsOfService.section9.title': 'IX. Limitazione di Responsabilità',
  'termsOfService.section9.1.title': '9.1 Ambito di Responsabilità',
  'termsOfService.section9.1.intro': 'Nella misura massima consentita dalla legge, non siamo responsabili di eventuali danni diretti, indiretti, incidentali, speciali o consequenziali derivanti dall\'utilizzo o dall\'impossibilità di utilizzare questo servizio, inclusi ma non limitati a:',
  'termsOfService.section9.1.item1': 'Perdita di profitti, perdita di dati o altre perdite economiche',
  'termsOfService.section9.1.item2': 'Interruzione dell\'attività',
  'termsOfService.section9.1.item3': 'Lesioni personali o perdita di proprietà',
  'termsOfService.section9.1.item4': 'Violazione della privacy',
  'termsOfService.section9.2.title': '9.2 Limite di Responsabilità',
  'termsOfService.section9.2.content': 'La nostra responsabilità totale non supera l\'importo totale che hai effettivamente pagato per questo servizio negli ultimi 12 mesi, o $100 (l\'importo più alto).',
  'termsOfService.section10.title': 'X. Terminazione del Servizio',
  'termsOfService.section10.1.title': '10.1 Terminazione da Parte dell\'Utente',
  'termsOfService.section10.1.content': 'Puoi smettere di utilizzare questo servizio e cancellare il tuo account in qualsiasi momento.',
  'termsOfService.section10.2.title': '10.2 Terminazione da Parte della Piattaforma',
  'termsOfService.section10.2.intro': 'Abbiamo il diritto di terminare o sospendere immediatamente il tuo account e servizio nelle seguenti circostanze:',
  'termsOfService.section10.2.item1': 'Violi questi Termini di Servizio',
  'termsOfService.section10.2.item2': 'Ti dedichi ad attività illegali',
  'termsOfService.section10.2.item3': 'Il tuo account non è stato utilizzato per un lungo periodo',
  'termsOfService.section10.2.item4': 'Requisiti legali o normativi',
  'termsOfService.section10.2.note': 'Dopo la terminazione del servizio, non potrai accedere al tuo account e al contenuto generato, salvo disposizione contraria della legge.',
  'termsOfService.section11.title': 'XI. Risoluzione delle Controversie',
  'termsOfService.section11.1.title': '11.1 Negoziazione',
  'termsOfService.section11.1.content': 'Se si verifica una controversia, entrambe le parti dovrebbero prima tentare di risolverla attraverso negoziazioni amichevoli.',
  'termsOfService.section11.2.title': '11.2 Legge Applicabile',
  'termsOfService.section11.2.content': 'Questi Termini di Servizio sono governati dalle leggi della Repubblica Popolare Cinese. Se entrambe le parti non possono risolvere la controversia attraverso negoziazioni, sarà sottoposta a un tribunale popolare con giurisdizione nella nostra località.',
  'termsOfService.section12.title': 'XII. Altre Disposizioni',
  'termsOfService.section12.1.title': '12.1 Modifica dei Termini',
  'termsOfService.section12.1.content': 'Ci riserviamo il diritto di modificare questi Termini di Servizio in qualsiasi momento. Le modifiche importanti ti saranno notificate almeno 30 giorni prima che entrino in vigore. L\'uso continuato del servizio indica la tua accettazione dei termini modificati.',
  'termsOfService.section12.2.title': '12.2 Divisibilità',
  'termsOfService.section12.2.content': 'Se una disposizione di questi Termini di Servizio è considerata invalida o inapplicabile, ciò non influisce sulla validità delle altre disposizioni.',
  'termsOfService.section12.3.title': '12.3 Accordo Completo',
  'termsOfService.section12.3.content': 'Questi Termini di Servizio costituiscono l\'accordo completo tra te e noi riguardo all\'utilizzo di questo servizio, sostituendo tutti gli accordi orali o scritti precedenti.',
  'termsOfService.section13.title': 'XIII. Contattaci',
  'termsOfService.section13.intro': 'Se hai domande su questi Termini di Servizio, contattaci tramite i seguenti metodi:',
  'termsOfService.section13.email': 'Email: {email}',
  'termsOfService.section13.hours': 'Orari di assistenza clienti: giorni feriali 9:00-18:00',
  
  // Footer
  'footer.brand.description': 'Fornisce servizi di generazione con IA.',
  'footer.joinUs': 'Lavora con noi',
  'footer.product.title': 'Prodotto',
  'footer.product.signup': 'Registrati',
  'footer.product.login': 'Accedi',
  'footer.product.workspace': 'Area di lavoro',
  'footer.product.works': 'Le mie opere',
  'footer.support.title': 'Supporto',
  'footer.support.help': 'Centro assistenza',
  'footer.support.about': 'Chi siamo',
  'footer.support.feedback': 'Feedback',
  'footer.support.contact': 'Contattaci',
  'footer.legal.title': 'Legale',
  'footer.legal.privacy': 'Informativa sulla privacy',
  'footer.legal.terms': 'Termini di servizio',
  'footer.legal.recharge': 'Accordo di ricarica',
  'footer.resources.title': 'Risorse',
  'footer.resources.invite': 'Invita amici',
  'footer.resources.account': 'Gestione account',
  'footer.resources.orders': 'Centro ordini',
  'footer.copyright': '© {year} {brand}. Tutti i diritti riservati.',
  'footer.description': 'Questa piattaforma fornisce servizi di generazione con IA',
  'footer.openRobotX.title': 'Open Robot X',
  'footer.openRobotX.description': 'Database globale di robotica umanoide con confronto specifiche e approfondimenti del settore',
  'footer.openRobotX.visit': 'Visita Open Robot X',
  'footer.ai2obj.title': 'ai2obj',
  'footer.ai2obj.description': 'Piattaforma di generazione completa con IA per creare contenuti digitali diversificati',
  'footer.aimatexMusic.title': 'AIMATEX-MUSIC',
  'footer.aimatexMusic.description': 'Musica cloud personale: scopri, playlist, Now Playing e libreria',
  
  // Pagina dei prezzi
  'pricing.title': 'Scegli il piano adatto a te',
  'pricing.plan.basic.sub': 'Base',
  'pricing.plan.pro.sub': 'Pro',
  'pricing.plan.team.sub': 'Team',
  'pricing.plan.popular': 'POPOLARE',
  'pricing.plan.button.select': 'Seleziona piano',
  'pricing.plan.button.subscribe': 'Abbonati ora',
  'pricing.plan.basic.videoQuota': '5/mese',
  'pricing.plan.basic.videoDuration': '6-10s',
  'pricing.plan.basic.videoQuality': '720P',
  'pricing.plan.pro.videoQuota': '30/mese',
  'pricing.plan.pro.videoDuration': '10-15s',
  'pricing.plan.pro.videoQuality': '1080P',
  'pricing.plan.team.videoQuota': '100/mese',
  'pricing.plan.team.videoDuration': '10-15s',
  'pricing.plan.team.videoQuality': '1080P/4K',
  'pricing.feature.videoQuota': 'Quota generazione video',
  'pricing.feature.videoDuration': 'Durata video',
  'pricing.feature.videoQuality': 'Qualità video',
  'pricing.feature.storyboard': 'Storyboard',
  'pricing.feature.workflow': 'Workflow',
  'pricing.feature.priorityQueue': 'Coda prioritaria',
  'pricing.feature.exclusiveChannel': 'Canale esclusivo',
  'pricing.feature.highestQuality': 'Modalità massima qualità',
  'pricing.feature.sdImage': 'Generazione immagini SD',
  'pricing.feature.unlimited': 'Illimitato',
  'pricing.feature.promptOptimization': 'Ottimizzazione prompt',
  'pricing.feature.imageSize': 'Dimensione immagine',
  'pricing.feature.storage': 'Spazio di archiviazione',
  'pricing.feature.commercialLicense': 'Licenza commerciale',
  'pricing.feature.apiAccess': 'Accesso API',
  'pricing.then': 'poi',
  'cta.title': 'Inizia a creare i tuoi video',
  'cta.description': 'Registrati ora e trasforma la tua creatività in opere video straordinarie con la tecnologia IA',
  'cta.button': 'Inizia gratuitamente',
  'technology.coreArchitecture': 'ARCHITETTURA CORE',
  'technology.workflowEngine.title': 'Motore di Workflow Visivo',
  'technology.workflowEngine.description': 'Supporto workflow visivo in arrivo. Ogni nodo è un controllo preciso sulla creatività.',
  'technology.node.checkpointLoader': 'Checkpoint Loader',
  'technology.node.clipTextPositive': 'CLIP Text (Positive)',
  'technology.node.clipTextNegative': 'CLIP Text (Negative)',
  'technology.node.ksamplerAdvanced': 'KSampler Advanced',
  'technology.node.vaeDecode': 'VAE Decode',
  'technology.node.previewImage': 'Preview Image',
  'technology.hud.systemResourceMonitor': 'Monitor Risorse di Sistema',
  'technology.hud.gpuVram': 'GPU VRAM',
  'technology.terminal.console': 'console — zsh',
  'technology.button.runWorkflow': 'Esegui Workflow',
  'technology.button.running': 'In esecuzione...',
  'technology.log.systemInitialized': '> Sistema inizializzato.',
  'technology.log.waitingForInput': '> In attesa di input utente...',
  'technology.log.loadingCheckpoint': 'Loading SDXL Checkpoint (fp16)...',
  'technology.log.tokenizingPrompt': 'Tokenizing positive prompt...',
  'technology.log.ksamplerSteps': 'KSampler: 30/30 steps (Euler A)',
  'technology.log.generationComplete': 'Generation complete.',
  'technology.benchmark.title': 'Benchmark delle Prestazioni Definitivo',
  'technology.benchmark.description': 'Per questo miglioramento di 0,5 secondi, abbiamo riscritto il 30% degli operatori sottostanti.',
  'technology.benchmark.fps.title': 'Velocità di Generazione (FPS)',
  'technology.benchmark.fps.subtitle': 'Comparison @ 1080p',
  'technology.benchmark.vram.title': 'Ottimizzazione VRAM',
  'technology.benchmark.vram.subtitle': 'Lower is better',
  'technology.benchmark.productX': 'ProductX',
  'technology.benchmark.others': 'Others',
  'technology.benchmark.standard': 'Standard',
  'technology.galaxy.openEcology': 'ECOLOGIA APERTA',
  'technology.galaxy.title': 'Universo Infinito di Modelli',
  'technology.galaxy.description': 'Supporto per connessione diretta Civitai, migliaia di modelli, caricamento con un clic.',
  'technology.galaxy.autoSync': 'Auto-Sync',
  
  // Pagina feedback
  'feedback.leftPanel.title.line1': 'Ascoltiamo',
  'feedback.leftPanel.title.line2': 'La tua voce',
  'feedback.leftPanel.description': 'Il tuo feedback è la forza trainante dietro il miglioramento del nostro prodotto. Che tu abbia trovato un bug o abbia un\'idea brillante per una nuova funzionalità, faccelo sapere.',
  'feedback.contact.helpDoc.title': 'Documentazione di aiuto',
  'feedback.contact.helpDoc.desc': 'Sfoglia FAQ e guide utente',
  'feedback.contact.email.title': 'Supporto email',
  'feedback.contact.service.title': 'Supporto online',
  'feedback.contact.service.hours': 'Giorni feriali 9:00 - 18:00',
  'feedback.type.suggestion.title': 'Suggerimento funzionalità',
  'feedback.type.suggestion.desc': 'Ho nuove idee o suggerimenti di miglioramento',
  'feedback.type.bug.title': 'Segnalazione bug',
  'feedback.type.bug.desc': 'Ho riscontrato un errore o un\'eccezione',
  'feedback.type.question.title': 'Richiesta di utilizzo',
  'feedback.type.question.desc': 'Non capisco come usare una funzionalità',
  'feedback.type.other.title': 'Altro',
  'feedback.type.other.desc': 'Altri tipi di feedback',
  'feedback.form.type.label': 'Tipo di feedback',
  'feedback.form.title.label': 'Riassunto breve',
  'feedback.form.title.placeholder': 'Descrivi il tuo problema o suggerimento in una frase',
  'feedback.form.title.required': 'Inserisci un titolo',
  'feedback.form.content.label': 'Descrizione dettagliata',
  'feedback.form.content.placeholder': 'Descrivi il contesto, i passaggi di riproduzione o suggerimenti specifici...',
  'feedback.form.content.required': 'Inserisci contenuti dettagliati',
  'feedback.form.attachment.label': 'Allegati (Opzionale)',
  'feedback.upload.dragText': 'Clicca o trascina i file qui per caricare',
  'feedback.upload.hint': 'Supporta formati JPG, PNG, PDF e altri, dimensione file singolo non superiore a 5MB',
  'feedback.upload.sizeLimit': 'La dimensione del file non può superare 5MB',
  'feedback.form.priority.label': 'Priorità',
  'feedback.priority.low.label': 'Bassa',
  'feedback.priority.low.desc': 'Non influisce sull\'utilizzo',
  'feedback.priority.medium.label': 'Media',
  'feedback.priority.medium.desc': 'Influisce sull\'esperienza utente',
  'feedback.priority.high.label': 'Alta',
  'feedback.priority.high.desc': 'Ostacola seriamente l\'utilizzo',
  'feedback.form.contact.label': 'Informazioni di contatto (Opzionale)',
  'feedback.form.contact.placeholder': 'Email o numero di telefono',
  'feedback.form.submit': 'Invia feedback',
  'feedback.submit.error': 'Invio fallito, riprova più tardi',
  'feedback.success.title': 'Feedback ricevuto!',
  'feedback.success.description': 'Grazie per il tuo prezioso feedback. Il nostro team prodotto leggerà attentamente ogni feedback. Se è una segnalazione bug, potremmo contattarti tramite le informazioni di contatto fornite.',
  'feedback.success.back': 'Indietro',
  'feedback.success.another': 'Invia un altro',
  // Pagina inviti
  'invite.partnerProgram': 'Programma Partner',
  'invite.title.line1': 'Invita amici',
  'invite.title.line2': 'Crea valore illimitato',
  'invite.reward.inviter': 'Guadagna {amount} di premio in contanti per ogni amico invitato.',
  'invite.reward.invitee': 'Il tuo amico riceve {amount} di bonus di benvenuto alla registrazione.',
  'invite.step1.title': '1. Condividi il link',
  'invite.step1.desc': 'Condividi il tuo link esclusivo sui social media',
  'invite.step2.title': '2. L\'amico si attiva',
  'invite.step2.desc': 'L\'amico completa registrazione e verifica',
  'invite.step3.title': '3. Preleva i guadagni',
  'invite.step3.desc': 'Guadagni istantanei, prelievo sul saldo',
  'invite.exclusiveCode': 'IL TUO CODICE ESCLUSIVO',
  'invite.copyCode': 'Copia codice',
  'invite.viewQrcode': 'Visualizza QR Code',
  'invite.stats.totalInvites': 'Totale invitati',
  'invite.stats.availableReward': 'Saldo disponibile',
  'invite.stats.totalReward': 'Guadagni totali',
  'invite.withdrawNow': 'Preleva ora',
  'invite.history.title': 'Cronologia inviti',
  'invite.filter.all': 'Tutti',
  'invite.filter.active': 'Attivi',
  'invite.filter.pending': 'In attesa',
  'invite.status.credited': 'Accreditato',
  'invite.status.pending': 'In attesa',
  'invite.history.empty': 'Nessun record',
  'invite.withdraw.title': 'Preleva guadagni',
  'invite.withdraw.cancel': 'Annulla',
  'invite.withdraw.confirm': 'Conferma prelievo',
  'invite.withdraw.amount': 'Importo prelievo',
  'invite.withdraw.note': '* L\'importo verrà trasferito direttamente sul saldo del tuo account.',
  'invite.withdraw.enterAmount': 'Inserisci l\'importo del prelievo',
  'invite.withdraw.insufficientBalance': 'Saldo insufficiente',
  'invite.withdraw.success': '¥{amount} prelevati con successo sul saldo',
  'invite.qrcode.title': 'Scansiona per unirti',
  'invite.copyLink': 'Copia link',
  'invite.copy.success': 'Copiato con successo',
  // Sezione Hero homepage
  'home.hero.badge': 'Assistente IA · Compagno · Partner',
  'home.hero.title': 'AIMATEX',
  'home.hero.subtitle': 'Il Tuo Compagno di Classe, Anima Gemella, Compagno di Squadra',
  'home.hero.description': 'AIMATEX è il tuo assistente IA, partner di apprendimento e compagno creativo. Forniamo soluzioni IA complete, rendendo l\'IA il tuo migliore partner nel lavoro, nello studio e nella creazione. Che si tratti di apprendimento in classe, collaborazione creativa o cooperazione di squadra, AIMATEX è il tuo partner affidabile.',
  'home.hero.cta.signup': 'Inizia gratis',
  'home.hero.cta.login': 'Accedi',
  'home.hero.cta.workspace': 'Vai all\'area di lavoro',
  // Sezione prodotti homepage
  'home.products.title': 'I Nostri Prodotti',
  'home.products.subtitle': 'Esplora prodotti IA innovativi sotto AIMATEX, ogni prodotto è il tuo migliore partner in diversi scenari',
  'home.products.seedance2.name': 'Seedance2',
  'home.products.seedance2.description': 'Partner di creazione immagine-video IA, trasformando immagini statiche in video dinamici, dando vita alla tua creatività',
  'home.products.ai2obj.name': 'AI2Obj',
  'home.products.ai2obj.description': 'Piattaforma di generazione e conversione oggetti 3D alimentata da IA, il tuo partner di creazione 3D',
  'home.products.openrobotx.name': 'OpenRobotX',
  'home.products.openrobotx.description': 'Esplora aziende globali di robot umanoidi, confronti di parametri e approfondimenti del settore, il tuo partner di ricerca robotica',
  'home.products.openclaw4j.name': 'OpenClaw4j',
  'home.products.openclaw4j.title': 'OpenClaw4j',
  'home.products.openclaw4j.description': 'Piattaforma di agenti autonomi — crea e distribuisci agenti intelligenti con OpenForgeX.',
  'home.products.openclaw4j.cta': 'Prova agente',
  'home.products.aimatexMusic.name': 'AIMATEX-MUSIC',
  'home.products.aimatexMusic.title': 'AIMATEX-MUSIC',
  'home.products.aimatexMusic.description': 'Spazio musica cloud personale — scopri brani, playlist collaborative, Now Playing e libreria cloud',
  'home.products.aimatexMusic.cta': 'Entra in Musica',
  'home.music.eyebrow': 'Suite AIMATEX',
  'home.music.title': 'AIMATEX-MUSIC',
  'home.music.subtitle': 'Il tuo spazio musica cloud — scopri, colleziona e ascolta insieme.',
  'home.music.feature.discover.title': 'Scopri',
  'home.music.feature.discover.desc': 'Cerca e importa brani nella libreria cloud.',
  'home.music.feature.playlist.title': 'Playlist',
  'home.music.feature.playlist.desc': 'Crea e condividi playlist collaborative.',
  'home.music.feature.nowPlaying.title': 'In riproduzione',
  'home.music.feature.nowPlaying.desc': 'Ascolto sincronizzato, preferiti e cronologia.',
  'home.music.feature.cloud.title': 'Libreria cloud',
  'home.music.feature.cloud.desc': 'Audio di alta qualità salvato nel cloud.',
  'home.music.cta': 'Apri AIMATEX-MUSIC',
'home.showcase.seedance2.eyebrow': 'Image to Video',
  'home.showcase.seedance2.title': 'Seedance2',
  'home.showcase.seedance2.subtitle': 'Turn still frames into cinematic motion with a next-gen creation engine.',
  'home.showcase.seedance2.f1.title': 'Image to Video',
  'home.showcase.seedance2.f1.desc': 'Upload a photo — AI invents light and motion.',
  'home.showcase.seedance2.f2.title': 'Cinema Quality',
  'home.showcase.seedance2.f2.desc': 'High-res output with stable, crisp detail.',
  'home.showcase.seedance2.f3.title': 'Smart Prompts',
  'home.showcase.seedance2.f3.desc': 'AI polishes rough ideas into film-ready prompts.',
  'home.showcase.seedance2.f4.title': 'Style Switch',
  'home.showcase.seedance2.f4.desc': 'Cyberpunk, oil paint, anime — one click.',
  'home.showcase.seedance2.cta': 'Enter Seedance2',
  'home.showcase.ai2obj.eyebrow': '3D Generation',
  'home.showcase.ai2obj.title': 'AI2Obj',
  'home.showcase.ai2obj.subtitle': 'An AI generation platform that turns ideas into usable digital assets.',
  'home.showcase.ai2obj.f1.title': 'Multimodal',
  'home.showcase.ai2obj.f1.desc': 'From text and images to 3D and content assets.',
  'home.showcase.ai2obj.f2.title': 'Object Convert',
  'home.showcase.ai2obj.f2.desc': 'Structure understanding and format conversion.',
  'home.showcase.ai2obj.f3.title': 'Creator Workflow',
  'home.showcase.ai2obj.f3.desc': 'Pipelines built for product and content teams.',
  'home.showcase.ai2obj.f4.title': 'Cloud Delivery',
  'home.showcase.ai2obj.f4.desc': 'Preview, export, and collaborate in the cloud.',
  'home.showcase.ai2obj.cta': 'Visit AI2Obj',
  'home.showcase.openrobotx.eyebrow': 'Robotics Intel',
  'home.showcase.openrobotx.title': 'OpenRobotX',
  'home.showcase.openrobotx.subtitle': 'Global humanoid robot companies, specs, and industry insights in one place.',
  'home.showcase.openrobotx.f1.title': 'World Map',
  'home.showcase.openrobotx.f1.desc': 'Major humanoid vendors and products covered.',
  'home.showcase.openrobotx.f2.title': 'Spec Compare',
  'home.showcase.openrobotx.f2.desc': 'Clear side-by-side capability and positioning.',
  'home.showcase.openrobotx.f3.title': 'Industry News',
  'home.showcase.openrobotx.f3.desc': 'Funding, launches, and tech movements tracked.',
  'home.showcase.openrobotx.f4.title': 'Research Partner',
  'home.showcase.openrobotx.f4.desc': 'Structured intel for selection and research.',
  'home.showcase.openrobotx.cta': 'Explore OpenRobotX',
  'home.showcase.openclaw4j.eyebrow': 'Autonomous Agents',
  'home.showcase.openclaw4j.title': 'OpenClaw4j',
  'home.showcase.openclaw4j.subtitle': 'Build and deploy intelligent agents with OpenForgeX — make agents run for real.',
  'home.showcase.openclaw4j.f1.title': 'Agent Orchestration',
  'home.showcase.openclaw4j.f1.desc': 'Multi-step planning and execution.',
  'home.showcase.openclaw4j.f2.title': 'Tool Calling',
  'home.showcase.openclaw4j.f2.desc': 'Connect APIs and business systems.',
  'home.showcase.openclaw4j.f3.title': 'Observable Runs',
  'home.showcase.openclaw4j.f3.desc': 'Transparent traces for debug and iteration.',
  'home.showcase.openclaw4j.f4.title': 'One-click Deploy',
  'home.showcase.openclaw4j.f4.desc': 'From prototype to live service fast.',
  'home.showcase.openclaw4j.cta': 'Try Agent',
  'home.products.learnMore': 'Scopri di più',
  // Sezione funzionalità homepage
  'home.features.title': 'Laboratorio creativo all-in-one.',
  'home.features.subtitle': 'Più della semplice generazione di video, è un potenziamento creativo completo.',
  'home.features.aiPrompt.title': 'Non sai scrivere prompt? L\'IA scrive per te',
  'home.features.aiPrompt.description': 'Completamente senza idee? Lascia che l\'IA scriva per te con un clic. Basta digitare alcune parole, l\'IA le perfeziona automaticamente in descrizioni cinematografiche, 10 secondi per generare. Vuoi cambiare stile? Clicca di nuovo, trasforma istantaneamente in cyberpunk/pittura a olio/anime.',
  'home.features.demo.userInput': 'un gatto',
  'home.features.demo.aiResult': 'Un elegante gatto persiano con pelo lungo bianco morbido e soffice e occhi ambrati, seduto su un davanzale soleggiato. Lo sfondo presenta un cielo azzurro chiaro e tende bianche fluttuanti. 4K ultra HD, illuminazione cinematografica, profondità di campo, fotografia professionale.',
  'home.features.demo.buttonText': 'Genera IA',
  'home.features.demo.buttonLoading': 'Generazione',
  'home.features.demo.thinkingText': 'L\'IA sta creando✨',
  'home.features.quality.title': 'Qualità cinematografica',
  'home.features.quality.description': 'Supporto nativo per output in risoluzione 4K, ogni fotogramma è accuratamente realizzato.',
  'home.features.imageToVideo.title': 'Immagine a video',
  'home.features.imageToVideo.description': 'Carica un\'immagine statica, l\'IA comprende l\'illuminazione e la fisica nella scena, genera automaticamente dinamiche successive, dando vita alle foto.',
  'home.features.multimodal.title': 'Ecosistema multimodale',
  'home.features.multimodal.description': 'Non solo supporta Stable Diffusion da testo a immagine, ma integra anche il trasferimento di stile di Midjourney e la sintesi audio di ElevenLabs. Completa tutte le creazioni in un flusso di lavoro.',
  
  // Sezione community della home
  'home.community.title': 'Esplora le comunità creative AI',
  'home.community.subtitle': 'Unisciti a milioni di creatori, condividi i tuoi capolavori AI e ottieni ispirazione e feedback',
  'home.community.hot': 'Popolare',
  'home.community.explore': 'Esplora community',
  'home.community.stats.works': 'Opere',
  'home.community.stats.creators': 'Creatori',
  'home.community.stats.views': 'Visualizzazioni',
  'home.community.image.title': 'Community immagini AI',
  'home.community.image.description': 'Scopri e condividi straordinarie immagini generate dall\'AI, dal fotorealismo all\'arte, dalle illustrazioni alla fotografia',
  'home.community.video.title': 'Community video AI',
  'home.community.video.description': 'Esplora fantastici video generati dall\'AI, impara tecniche creative e scambia esperienze con creatori di video globali',
  'home.community.music.title': 'Community musica AI',
  'home.community.music.description': 'Ascolta bellissime melodie composte dall\'AI, condividi le tue opere musicali e trova appassionati di musica affini',
  'home.community.3d.title': 'Community modelli 3D AI',
  'home.community.3d.description': 'Esplora il mondo dei modelli 3D generati dall\'AI, dall\'architettura ai personaggi, dai giochi al design industriale',
  'home.community.voice.title': 'Community voce AI',
  'home.community.voice.description': 'Sperimenta la sintesi vocale AI realistica, doppiaggio, audiolibri, clonazione vocale e dai vita alle tue creazioni',
  'home.community.text.title': 'Community testo AI',
  'home.community.text.description': 'Condividi eccellenti testi creati dall\'AI, romanzi, poesie, sceneggiature, copywriting e ispira la tua creatività letteraria',
  
  // Pagina di fatturazione
  'billing.page.title': 'Centro finanziario',
  'billing.page.description': 'Gestisci le tue transazioni e i dettagli di fatturazione',
  'billing.button.refresh': 'Aggiorna',
  'billing.button.recharge': 'Ricarica',
  'billing.button.reset': 'Ripristina',
  'billing.button.apply': 'Applica filtri',
  'billing.balance.cny': 'Saldo CNY',
  'billing.balance.usdt': 'Saldo USDT',
  'billing.balance.usd': 'Saldo USD',
  'billing.balance.token': 'Saldo Token',
  'billing.balance.frozen': 'Congelato',
  'billing.type.frozen': 'Fondi congelati',
  'billing.type.aiModelFee': 'Tariffa modello IA',
  'billing.type.recharge': 'Ricarica',
  'billing.type.refund': 'Rimborso',
  'billing.type.reward': 'Ricompensa',
  'billing.type.all': 'Tutti i tipi',
  'billing.coin.all': 'Tutte le valute',
  'billing.coin.usdt': 'USDT',
  'billing.coin.cny': 'CNY',
  'billing.coin.usd': 'USD',
  'billing.coin.token': 'TOKEN',
  'billing.table.type': 'Tipo',
  'billing.table.coinType': 'Valuta',
  'billing.table.time': 'Ora',
  'billing.table.amount': 'Importo',
  'billing.table.remark': 'Nota',
  'billing.table.balance': 'Saldo',
  'billing.table.empty': 'Nessun record',
  'billing.filter.title': 'Opzioni filtro',
  'billing.filter.button': 'Filtra e data',
  'billing.filter.changeType': 'Tipo di transazione',
  'billing.filter.coinType': 'Tipo di valuta',
  'billing.filter.remark': 'Ricerca note',
  'billing.filter.remarkPlaceholder': 'Inserisci parole chiave',
  'billing.filter.remarkSearch': 'Ricerca note',
  'billing.filter.dateQuick': 'Data rapida',
  'billing.filter.dateCustom': 'Data personalizzata',
  'billing.filter.dateTo': 'a',
  'billing.filter.days7': 'Ultimi 7 giorni',
  'billing.filter.days30': 'Ultimi 30 giorni',
  'billing.filter.days90': 'Ultimi 3 mesi',
  'billing.placeholder.changeType': 'Tipo di modifica',
  'billing.placeholder.coinType': 'Valuta',
  'billing.placeholder.remark': 'Ricerca note',
  'billing.message.fetchBalanceError': 'Impossibile recuperare il saldo',
  'billing.message.fetchRecordsError': 'Impossibile recuperare i record di fatturazione',
  'billing.message.tryAgain': 'Impossibile recuperare i record di fatturazione, riprova più tardi',
  
  // Pagina di ricarica
  'recharge.page.title': 'Ricarica account',
  'recharge.page.backLink': 'Torna alla fatturazione',
  'recharge.balance.title': 'Saldo account',
  'recharge.balance.refresh': 'Aggiorna',
  'recharge.section.coinType': 'Valuta di ricarica',
  'recharge.section.paymentMethod': 'Metodo di pagamento',
  'recharge.section.amount': 'Importo ricarica',
  'recharge.order.title': 'Dettagli ordine',
  'recharge.order.type': 'Tipo di ricarica',
  'recharge.order.typeValue': 'Ricarica saldo account',
  'recharge.order.account': 'Account',
  'recharge.order.accountLoading': 'Caricamento...',
  'recharge.order.paymentMethod': 'Metodo di pagamento',
  'recharge.order.paymentMethodPlease': 'Seleziona',
  'recharge.order.total': 'Importo totale',
  'recharge.button.pay': 'Paga ora',
  'recharge.button.customize': 'Importo personalizzato',
  'recharge.placeholder.customAmount': 'Inserisci importo personalizzato',
  'recharge.security.ssl': 'Trasmissione crittografata SSL, pagamento sicuro',
  'recharge.security.agreement': 'Cliccando su Paga, accetti',
  'recharge.security.agreementLink': 'Accordo servizio di ricarica',
  'recharge.empty.noCurrency': 'Nessuna valuta supportata',
  'recharge.empty.noPaymentMethod': 'Nessun metodo di pagamento disponibile per {currency}',
  'recharge.empty.pleaseSelectCurrency': 'Seleziona prima la valuta',
  'recharge.empty.pleaseSelectPayment': 'Seleziona prima il metodo di pagamento',
  'recharge.empty.noProducts': 'Nessun prodotto disponibile',
  'recharge.empty.noPresets': 'Nessun importo predefinito per {currency}',
  'recharge.message.invalidAmount': 'Inserisci un importo valido',
  'recharge.message.selectPaymentMethod': 'Seleziona un metodo di pagamento',
  'recharge.message.selectAmount': 'Seleziona l\'importo di ricarica',
  'recharge.message.fetchBalanceError': 'Impossibile recuperare il saldo, riprova più tardi',
  'recharge.message.fetchUserInfoError': 'Impossibile recuperare le informazioni utente',
  'recharge.message.fetchCurrenciesError': 'Impossibile recuperare le valute, riprova più tardi',
  'recharge.message.fetchPaymentMethodsError': 'Impossibile recuperare i metodi di pagamento, riprova più tardi',
  'recharge.message.fetchCreemProductsError': 'Impossibile recuperare i prodotti Creem, riprova più tardi',
  'recharge.message.fetchCreemProductsWarning': 'Impossibile recuperare i prodotti Creem',
  'recharge.message.orderCreated': 'Ordine creato con successo',
  'recharge.message.orderCreateFailed': 'Impossibile creare l\'ordine di ricarica',
  'recharge.message.paymentProcessing': 'Apertura pagina di pagamento, completa il pagamento...',
  'recharge.message.popupBlocked': 'Impossibile aprire la finestra di pagamento, controlla le impostazioni popup del browser',
  'recharge.message.paymentUrlError': 'Impossibile ottenere l\'URL di pagamento',
  'recharge.message.checkoutSessionError': 'Impossibile creare la sessione di pagamento',
  'recharge.message.paymentError': 'Elaborazione pagamento fallita, riprova più tardi',
  'recharge.message.redirecting': 'Reindirizzamento alla pagina di pagamento, completa il pagamento...',
  'recharge.message.paymentUrlFailed': 'URL di pagamento non disponibile',
  'recharge.message.paymentSuccess': 'Pagamento riuscito! Saldo aggiornato',
  'recharge.message.orderCancelled': 'Ordine annullato',
  'recharge.message.paymentFailed': 'Pagamento fallito',
  'recharge.message.orderExpired': 'Scaduto',
  'recharge.message.queryOrderError': 'Impossibile interrogare lo stato dell\'ordine',
  'recharge.message.rechargeError': 'Richiesta di ricarica fallita, riprova più tardi',

  // Pagina ordini
  'orders.title': 'Storico ordini',
  'orders.subtitle': 'Visualizza tutti i tuoi ordini di ricarica e i loro stati',
  'orders.refresh': 'Aggiorna',
  'orders.goToRecharge': 'Ricarica',

  // Schede statistiche
  'orders.stats.totalOrders': 'Ordini totali',
  'orders.stats.pending': 'In attesa',
  'orders.stats.paid': 'Pagato',
  'orders.stats.totalAmount': 'Totale ricaricato',

  // Colonne tabella
  'orders.table.orderNo': 'N° ordine',
  'orders.table.createTime': 'Creato il',
  'orders.table.amount': 'Importo',
  'orders.table.paymentMethod': 'Metodo di pagamento',
  'orders.table.status': 'Stato',
  'orders.table.action': 'Azione',
  'orders.table.view': 'Visualizza',
  'orders.table.cancel': 'Annulla',
  'orders.table.empty': 'Nessun ordine',

  // Stato ordine
  'orders.status.pending': 'In attesa',
  'orders.status.paid': 'Pagato',
  'orders.status.success': 'Completato',
  'orders.status.cancelled': 'Annullato',
  'orders.status.failed': 'Fallito',
  'orders.status.expired': 'Scaduto',
  'orders.status.all': 'Tutti gli stati',

  // Metodi di pagamento
  'orders.payment.alipay': 'Alipay',
  'orders.payment.wechat': 'WeChat Pay',
  'orders.payment.bank': 'Carta bancaria',
  'orders.payment.usdt': 'USDT',
  'orders.payment.creem': 'Creem',
  'orders.payment.all': 'Tutti i metodi',

  // Valuta
  'orders.coin.all': 'Tutte le valute',

  // Filtri
  'orders.filter.title': 'Opzioni filtro',
  'orders.filter.button': 'Filtra ordini',
  'orders.filter.reset': 'Ripristina',
  'orders.filter.apply': 'Applica',
  'orders.filter.orderStatus': 'Stato ordine',
  'orders.filter.paymentMethod': 'Metodo di pagamento',
  'orders.filter.coinType': 'Tipo di valuta',
  'orders.filter.orderNoSearch': 'Cerca N° ordine',
  'orders.filter.quickDate': 'Data rapida',
  'orders.filter.customDate': 'Data personalizzata',
  'orders.filter.dateTo': 'a',
  'orders.filter.last7Days': 'Ultimi 7 giorni',
  'orders.filter.last30Days': 'Ultimi 30 giorni',
  'orders.filter.last3Months': 'Ultimi 3 mesi',

  // Ricerca e input
  'orders.search.placeholder': 'Cerca numero ordine',
  'orders.input.orderNo': 'Inserisci numero ordine',
  'orders.select.orderStatus': 'Stato ordine',
  'orders.select.paymentMethod': 'Metodo di pagamento',
  'orders.select.coinType': 'Valuta',

  // Messaggi
  'orders.message.fetchError': 'Impossibile recuperare ordini',
  'orders.message.fetchErrorRetry': 'Impossibile recuperare ordini, riprova più tardi',
  'orders.message.statsError': 'Impossibile recuperare statistiche',
  'orders.message.cancelSuccess': 'Ordine annullato',
  'orders.message.cancelError': 'Impossibile annullare ordine',
  'orders.message.cancelErrorRetry': 'Impossibile annullare ordine, riprova più tardi',
  'orders.message.viewOrder': 'N° ordine: {orderNo}',

  // Dialogo di conferma
  'orders.confirm.cancel': 'Sei sicuro di voler annullare questo ordine?',
  'orders.confirm.ok': 'OK',
  'orders.confirm.cancelButton': 'Annulla',

  // Pagina Lavora con noi
  'joinUs.seo.title': 'Unisciti a PROTX - Ricerca dell\'eccellenza',
  'joinUs.seo.description': 'Unisciti al team PROTX e persegui l\'esperienza utente e il design prodotto definitivi con noi',
  'joinUs.hero.eyebrow': 'JOIN PROTX',
  'joinUs.hero.title': 'Ricerca dell\'eccellenza',
  'joinUs.hero.title2': 'Definire il futuro attraverso il design',
  'joinUs.hero.subtitle': 'PROTX è un team dedicato a creare l\'esperienza utente e il design prodotto definitivi. Crediamo che ogni pixel conti, ogni interazione meriti di essere curata meticolosamente. Se condividi la nostra instancabile ricerca dell\'eccellenza, unisciti a noi.',
  'joinUs.hero.cta': 'Vedi posizioni aperte',
  'joinUs.hero.video': 'Guarda la nostra storia',
  
  'joinUs.values.eyebrow': 'I NOSTRI VALORI',
  'joinUs.values.title': 'I nostri valori fondamentali',
  'joinUs.values.subtitle': 'Questi valori fondamentali definiscono chi siamo e come lavoriamo insieme',
  'joinUs.values.innovation.title': 'Guidati dall\'innovazione',
  'joinUs.values.innovation.desc': 'Crediamo che l\'innovazione sia la forza che cambia il mondo, incoraggiando ogni idea rivoluzionaria.',
  'joinUs.values.collaboration.title': 'Successo collaborativo',
  'joinUs.values.collaboration.desc': 'Collaborazione tra team per creare insieme risultati straordinari.',
  'joinUs.values.excellence.title': 'Ricerca dell\'eccellenza',
  'joinUs.values.excellence.desc': 'Superare costantemente i limiti per l\'esperienza definitiva.',
  'joinUs.values.passion.title': 'Passione e focus',
  'joinUs.values.passion.desc': 'Amore per la tecnologia, dedizione al prodotto.',
  'joinUs.values.impact.title': 'Creare impatto',
  'joinUs.values.impact.desc': 'Potenziare l\'espressione creativa di tutti con la tecnologia IA.',
  
  'joinUs.positions.eyebrow': 'POSIZIONI APERTE',
  'joinUs.positions.title': 'Posizioni aperte',
  'joinUs.positions.subtitle': 'Trova il ruolo che fa per te e inizia il tuo nuovo percorso professionale',
  'joinUs.category.engineering': 'Ingegneria',
  'joinUs.category.product': 'Prodotto e Design',
  'joinUs.category.operations': 'Operations e Marketing',
  'joinUs.position.seniorFrontend': 'Senior Frontend Engineer',
  'joinUs.position.backendEngineer': 'Backend Engineer',
  'joinUs.position.mlEngineer': 'Ingegnere IA/ML',
  'joinUs.position.productManager': 'Product Manager',
  'joinUs.position.uxDesigner': 'UX Designer',
  'joinUs.position.communityManager': 'Community Manager',
  'joinUs.position.contentCreator': 'Content Creator',
  'joinUs.location.remote': 'Remoto',
  'joinUs.location.beijing': 'Pechino',
  'joinUs.location.shanghai': 'Shanghai',
  'joinUs.location.shenzhen': 'Shenzhen',
  'joinUs.type.fulltime': 'Full-time',
  'joinUs.type.parttime': 'Part-time',
  
  'joinUs.benefits.eyebrow': 'BENEFIT',
  'joinUs.benefits.title': 'Cosa offriamo',
  'joinUs.benefits.subtitle': 'Unisciti a noi e goditi benefit completi e supporto',
  'joinUs.benefit.flexible.title': 'Lavoro flessibile',
  'joinUs.benefit.flexible.desc': 'Orari flessibili e opzioni di lavoro remoto',
  'joinUs.benefit.equity.title': 'Stock option',
  'joinUs.benefit.equity.desc': 'Cresci con l\'azienda e condividi il nostro successo',
  'joinUs.benefit.health.title': 'Assicurazione sanitaria',
  'joinUs.benefit.health.desc': 'Assicurazione sanitaria completa e benefit benessere',
  'joinUs.benefit.growth.title': 'Crescita professionale',
  'joinUs.benefit.growth.desc': 'Opportunità continue di apprendimento e sviluppo',
  
  'joinUs.cta.title': 'Pronto per iniziare?',
  'joinUs.cta.subtitle': 'Se sei appassionato della nostra missione, aspettiamo la tua candidatura',
  'joinUs.cta.button': 'Candidati ora',
  
  'joinUs.modal.title': 'Candidatura',
  'joinUs.apply.success': 'Candidatura inviata! Ti contatteremo presto.',
  'joinUs.form.name': 'Nome',
  'joinUs.form.name.required': 'Inserisci il tuo nome',
  'joinUs.form.name.placeholder': 'Inserisci il tuo nome',
  'joinUs.form.email': 'Email',
  'joinUs.form.email.required': 'Inserisci la tua email',
  'joinUs.form.email.invalid': 'Inserisci un indirizzo email valido',
  'joinUs.form.email.placeholder': 'Inserisci la tua email',
  'joinUs.form.phone': 'Telefono',
  'joinUs.form.phone.placeholder': 'Inserisci il tuo numero di telefono',
  'joinUs.form.experience': 'Esperienza lavorativa',
  'joinUs.form.experience.placeholder': 'Seleziona il tuo livello di esperienza',
  'joinUs.form.experience.0-2': '0-2 anni',
  'joinUs.form.experience.3-5': '3-5 anni',
  'joinUs.form.experience.5-10': '5-10 anni',
  'joinUs.form.experience.10+': '10+ anni',
  'joinUs.form.resume': 'Curriculum',
  'joinUs.form.resume.hint': 'Clicca o trascina il file per caricare',
  'joinUs.form.resume.format': 'Formati PDF, DOC, DOCX supportati',
  'joinUs.form.message': 'Lettera di presentazione',
  'joinUs.form.message.placeholder': 'Parlaci di te e perché vuoi unirti a noi',
  'joinUs.form.submit': 'Invia candidatura',
  'joinUs.form.loginTip': 'Accedi prima di inviare per visualizzare lo storico delle candidature',
  'joinUs.form.goLogin': 'Accedi',
  'joinUs.form.resume.sizeLimit': 'La dimensione del file non può superare 10 MB',
  
  // Le mie candidature
  'joinUs.myApplications.eyebrow': 'LE MIE CANDIDATURE',
  'joinUs.myApplications.title': 'Storico candidature',
  'joinUs.myApplications.empty': 'Nessuna candidatura ancora. Invia il tuo CV ora!',
  'joinUs.myApplications.viewDetail': 'Vedi dettagli',
  'joinUs.myApplications.detailTitle': 'Dettagli candidatura',
  'joinUs.status.pending': 'In attesa',
  'joinUs.status.reviewing': 'In revisione',
  'joinUs.status.interview': 'Colloquio',
  'joinUs.status.accepted': 'Accettato',
  'joinUs.status.rejected': 'Rifiutato',
  'joinUs.detail.basicInfo': 'Informazioni di base',
  'joinUs.detail.positionInfo': 'Informazioni sulla posizione',
  'joinUs.detail.position': 'Posizione richiesta',
  'joinUs.detail.category': 'Categoria',
  'joinUs.detail.location': 'Località',
  'joinUs.detail.applyTime': 'Data di candidatura',
  'joinUs.detail.downloadResume': 'Scarica CV',
  'joinUs.detail.status': 'Stato candidatura',

  // Pagina About
  'about.hero.title1': 'Core Open Source.',
  'about.hero.title2': 'Possibilità infinite.',
  'about.hero.subtitle1': 'Basato su',
  'about.hero.subtitle2': 'e',
  'about.hero.subtitle3': 'ecosistema.',
  'about.hero.description': 'Impacchettiamo lo stack tecnologico AI generativa più all\'avanguardia del 2025 in un\'esperienza interattiva definitiva.',
  'about.tech.poweredBy': 'Powered by',
  'about.philosophy.title1': 'Più che generazione.',
  'about.philosophy.title2': 'Questo è un processo completo',
  'about.philosophy.title3': 'motore di creatività.',
  'about.philosophy.description': 'Dal controllo preciso nel text-to-image alla simulazione fisica nella generazione video, perseguiamo i limiti della tecnologia.',
  'about.bento.comfy.title': 'Controllo di precisione a livello di nodi.',
  'about.bento.comfy.description': 'Costruito sull\'architettura a nodi ComfyUI, supportando il controllo pose ControlNet e il trasferimento di stile IP-Adapter. Incapsuliamo la logica complessa dei nodi in slider intuitivi, rendendo ogni generazione esattamente come immagini.',
  'about.bento.opensource.title': 'Abbracciare l\'open source.',
  'about.bento.opensource.description': 'Basato su Stable Diffusion 3.5 & XL Turbo. Non solo generazione ultraveloce, ma anche massiccio supporto di modelli LoRA dalla community.',
  'about.bento.video.title': 'Architettura video DiT.',
  'about.bento.video.description': 'Introducendo Diffusion Transformer (DiT) con meccanismo di attenzione spazio-temporale, raggiungendo simulazione del mondo fisico a livello SORA.',
  'about.bento.audio.title': 'Sincronizzazione audio-visiva, risveglio sensoriale.',
  'about.bento.audio.description': 'Oltre il visivo. Integrato con i più recenti modelli di generazione audio, supportando Text-to-Audio e allineamento video automatico. Dalla vista al suono, costruendo un\'esperienza immersiva completa.',
  'about.techSection.title': 'Architettura tecnica.',
  'about.techSection.description': 'Approfondisci il motore centrale che alimenta ProductX.',
  'about.techCard.sd.title': 'La fondazione dell\'arte generativa.',
  'about.techCard.sd.description': 'Integriamo profondamente i più recenti modelli di generazione Stable Diffusion. Attraverso VAE personalizzato e sampler ottimizzati, raggiungiamo una generazione del 300% più veloce mantenendo una qualità d\'immagine squisita.',
  'about.techCard.spec.baseModel': 'Modello base',
  'about.techCard.spec.resolution': 'Risoluzione',
  'about.techCard.spec.resolution.value': 'Fino a 4K Upscaling',
  'about.techCard.spec.control': 'Controllo',
  'about.techCard.spec.speed': 'Velocità',
  'about.techCard.spec.speed.value': '< 1s (Modalità Turbo)',
  'about.techCard.video.title': 'Motore fisico video di nuova generazione.',
  'about.techCard.video.description': 'Abbandonando la logica tradizionale dell\'animazione 2D, adottando la più recente architettura DiT (Diffusion Transformer) del 2025. Il modello comprende illuminazione, gravità e fisica del movimento, generando non solo video, ma mondi dinamici fisicamente accurati.',
  'about.techCard.spec.architecture': 'Architettura',
  'about.techCard.spec.frameRate': 'Frame rate',
  'about.techCard.spec.frameRate.value': 'Interpolazione 24 / 60 FPS',
  'about.techCard.spec.consistency': 'Consistenza',
  'about.techCard.spec.consistency.value': 'Alta stabilità temporale',
  'about.techCard.spec.length': 'Durata',
  'about.techCard.spec.length.value': 'Estensione loop infinito',
  'about.techCard.img2img.title': 'Image-to-image e trasferimento di stile.',
  'about.techCard.img2img.description': 'Usando le tecnologie IP-Adapter e T2I-Adapter, realizziamo il trasferimento di stile zero-shot. Carica un\'immagine di riferimento per replicare istantaneamente composizione, illuminazione e stile artistico, liberando possibilità creative infinite.',
  'about.techCard.spec.technology': 'Tecnologia',
  'about.techCard.spec.precision': 'Precisione',
  'about.techCard.spec.precision.value': 'Inpainting pixel-perfect',
  'about.cta.title': 'Pronto a sperimentare il futuro?',
  'about.cta.description': 'Unisciti ai ranghi dei creatori professionisti e libera il potenziale definitivo dell\'IA.',
  'about.cta.button.start': 'Inizia ora',
  'about.cta.button.docs': 'Leggi la documentazione',
  
  // Community
  'community.explore.title': 'Esplora le comunità',
  'community.explore.subtitle': 'Scopri ispirazione, remixa i flussi di lavoro e connettiti con migliaia di creatori IA.',
  'community.posts': '{count} post',
  'community.empty': 'Nessun canale della comunità',
  'community.loadFailed': 'Caricamento fallito',
  'community.noPosts': 'Ancora nessun post',
  'community.challenge.loadFailed': 'Caricamento dati sfida fallito',
  
  'common.loadFailed': 'Caricamento fallito',
  'common.operationFailed': 'Operazione fallita',
  'common.error': 'Operazione fallita',
  'common.publish': 'Pubblica',
  'common.back': 'Indietro',
  'common.backToCommunity': 'Torna alla comunità',
  'common.copy': 'Copia',
  'common.copied': 'Copiato',
  'common.follow': 'Segui',
  'common.processing': 'Elaborazione...',
  'common.viewCount': '{count} visualizzazioni',
  'common.loadMore': 'Carica altro',
  'common.search': 'Cerca...',
  'common.notFound': 'Non trovato',
  'common.description': 'Descrizione',
  
  'user.followSuccess': 'Seguito con successo',
  'user.unfollowSuccess': 'Smesso di seguire con successo',
  'user.following': 'Segui',
  'user.mutual_follow': 'Reciproco',
  
  'post.untitled': 'Creazione senza titolo',
  'post.prompt': 'Prompt',
  'post.negativePrompt': 'Prompt negativo',
  'post.details': 'Dettagli',
  'post.model': 'Modello',
  'post.resolution': 'Risoluzione',
  'post.steps': 'Passaggi',
  'post.cfgScale': 'Scala di guida',
  'post.remix': 'Remix / Prova questo',
  
  'challenge.status.upcoming': 'In arrivo',
  'challenge.status.live': 'In corso',
  'challenge.status.voting': 'Votazione',
  'challenge.status.ended': 'Terminato',
  'challenge.status.unknown': 'Sconosciuto',
  'challenge.allChallenges': 'Tutte le sfide',
  'challenge.entriesCount': '{count} partecipazioni',
  'challenge.tab.submissions': 'Partecipazioni',
  'challenge.tab.rules': 'Regole e informazioni',
  'challenge.requirements': 'Requisiti',
  'challenge.req.original': 'Solo creazioni originali.',
  'challenge.req.model': 'Deve usare il modello: {model}',
  'challenge.req.tags': 'Deve includere tag:',
  'challenge.req.resolution': 'La risoluzione deve essere almeno 1024x1024.',
  'challenge.req.nsfw': 'Nessun contenuto NSFW.',
  'challenge.timeRemaining': 'Tempo rimanente',
  'challenge.startsIn': 'Inizia tra',
  'challenge.notStarted': 'Sfida non ancora iniziata',
  'challenge.closed': 'Sfida chiusa',
  'challenge.submitEntry': 'Invia partecipazione',
  'challenge.viewWinners': 'Vedi vincitori',
  'challenge.readRulesTip': 'Leggi le regole prima di inviare',
  'challenge.prizePool': 'Montepremi',
  'challenge.totalValue': 'Valore totale',
  'challenge.rank.1st': '1° posto',
  'challenge.rank.2nd': '2° posto',
  'challenge.rank.3rd': '3° posto',
  'challenge.share': 'Condividi sfida',
  'challenge.noEntries': 'Ancora nessuna partecipazione. Sii il primo!',
  'challenge.noChallenges': 'Nessuna sfida trovata',
  // MediaTools
  'mediaTools.tab.imageCompress': 'Compressione immagini',
  'mediaTools.tab.videoCompress': 'Compressione video',
  'mediaTools.tab.audioCompress': 'Compressione audio',
  'mediaTools.tab.formatConvert': 'Conversione formato',
  // ImageCompress
  'imageCompress.title': 'Strumento professionale di compressione immagini',
  'imageCompress.subtitle': 'Compressione intelligente, qualità professionale',
  'imageCompress.upload': 'Carica immagini',
  'imageCompress.addImages': 'Aggiungi immagini',
  'imageCompress.uploadToStart': 'Carica immagini per iniziare la compressione',
  'imageCompress.settings': 'Impostazioni',
  'imageCompress.clearAll': 'Cancella tutto',
  'imageCompress.totalSavings': 'Spazio risparmiato',
  'imageCompress.totalSize': 'Dimensione totale',
  'imageCompress.quality': 'Qualità',
  'imageCompress.resize': 'Ridimensiona',
  'imageCompress.scalePercent': 'Scala %',
  'imageCompress.customPx': 'Px personalizzato',
  'imageCompress.presetSize': 'Dimensione predefinita',
  'imageCompress.width': 'Larghezza',
  'imageCompress.height': 'Altezza',
  'imageCompress.format': 'Formato',
  'imageCompress.format.auto': 'Auto (originale)',
  'imageCompress.format.jpeg': 'JPEG (foto)',
  'imageCompress.format.png': 'PNG (senza perdita)',
  'imageCompress.format.webp': 'WebP (migliore)',
  'imageCompress.pngLossless': 'PNG è senza perdita. Il controllo qualità è nascosto.',
  'imageCompress.cacheSettings': 'Impostazioni cache',
  'imageCompress.cacheTooltip': 'Quando abilitato, le immagini caricate verranno salvate nella cache del browser e ripristinate dopo il refresh della pagina.',
  'imageCompress.saveToCache': 'Salva immagini nella cache del browser',
  'imageCompress.batchProcessing': 'Elaborazione batch',
  'imageCompress.batchTooltip': 'Quando abilitato, la compressione verrà applicata a tutte le {count} immagini con le impostazioni correnti.',
  'imageCompress.applyToAll': 'Applica impostazioni a tutte le immagini ({count})',
  'imageCompress.compress': 'Applica e comprimi',
  'imageCompress.compressAll': 'Applica e comprimi tutto ({count})',
  'imageCompress.compressing': 'Compressione in corso...',
  'imageCompress.compressAllProgress': 'Compressione di {count} immagini...',
  'imageCompress.download': 'Scarica immagine',
  'imageCompress.downloadAll': 'Scarica tutto ({count})',
  'imageCompress.downloadAllCheckbox': 'Scarica tutte le {count} immagini',
  'imageCompress.original': 'Originale',
  'imageCompress.compressed': 'Compresso',
  // Messages
  'imageCompress.message.compressed': 'Compressione riuscita!',
  'imageCompress.message.larger': 'Il file di output è più grande. Prova a ridurre la qualità.',
  'imageCompress.message.failed': 'Compressione fallita',
  'imageCompress.message.batchSuccess': '{success} immagine/i compressa/e con successo{failed}',
  'imageCompress.message.batchFailed': 'Tutte le compressioni sono fallite',
  'imageCompress.message.noImagesToDownload': 'Nessuna immagine compressa da scaricare',
  'imageCompress.message.downloading': 'Download di {count} immagine/i...',
  // Preset sizes
  'imageCompress.preset.instagramPost': 'Post Instagram (1:1)',
  'imageCompress.preset.square': 'Quadrato (1:1)',
  'imageCompress.preset.facebookCover': 'Copertina Facebook (16:9)',
  'imageCompress.preset.twitterHeader': 'Intestazione Twitter (3:1)',
  'imageCompress.preset.youtubeThumbnail': 'Anteprima YouTube (16:9)',
  'imageCompress.preset.facebookPost': 'Post Facebook (1.91:1)',
  'imageCompress.preset.instagramStory': 'Storia Instagram (9:16)',
  'imageCompress.preset.tiktok': 'TikTok (9:16)',
  'imageCompress.preset.4kUHD': '4K UHD (16:9)',
  'imageCompress.preset.2kQHD': '2K QHD (16:9)',
  'imageCompress.preset.fullHD': 'Full HD (16:9)',
  'imageCompress.preset.hd': 'HD (16:9)',
  'imageCompress.preset.landscape16:9': 'Paesaggio 16:9',
  'imageCompress.preset.classic4:3': 'Classico 4:3',
  'imageCompress.preset.photo3:2': 'Foto 3:2',
  'imageCompress.preset.ultrawide21:9': 'Ultrawide 21:9',
  'imageCompress.preset.a4Portrait': 'A4 Verticale (8.27×11.69")',
  'imageCompress.preset.a4Landscape': 'A4 Orizzontale (11.69×8.27")',
  'imageCompress.preset.letterPortrait': 'Letter Verticale (8.5×11")',
  // AudioCompress
  'audioCompress.title': 'Strumento professionale di compressione audio',
  'audioCompress.subtitle': 'Compressione basata su browser, privacy protetta',
  'audioCompress.upload': 'Carica audio',
  'audioCompress.uploadNew': 'Fai clic per caricare nuovo audio',
  'audioCompress.uploadToStart': 'Carica audio per iniziare la compressione',
  'audioCompress.settings': 'Impostazioni',
  'audioCompress.clearAll': 'Cancella tutto',
  'audioCompress.totalSavings': 'Spazio risparmiato',
  'audioCompress.totalSize': 'Dimensione totale',
  'audioCompress.audioInfo': 'Info audio',
  'audioCompress.quality': 'Qualità',
  'audioCompress.bitrate': 'Bitrate',
  'audioCompress.bitrate.320': '320 kbps (Qualità massima)',
  'audioCompress.bitrate.256': '256 kbps (Alta qualità)',
  'audioCompress.bitrate.192': '192 kbps (Qualità standard)',
  'audioCompress.bitrate.128': '128 kbps (Qualità media)',
  'audioCompress.bitrate.96': '96 kbps (Bassa qualità)',
  'audioCompress.bitrate.64': '64 kbps (Qualità minima)',
  'audioCompress.format': 'Formato',
  'audioCompress.format.mp3': 'MP3 (Consigliato)',
  'audioCompress.format.ogg': 'OGG',
  'audioCompress.format.aac': 'AAC',
  'audioCompress.format.wav': 'WAV',
  'audioCompress.sampleRate': 'Frequenza di campionamento',
  'audioCompress.sampleRate.48000': '48000 Hz',
  'audioCompress.sampleRate.44100': '44100 Hz (Qualità CD)',
  'audioCompress.sampleRate.32000': '32000 Hz',
  'audioCompress.sampleRate.22050': '22050 Hz',
  'audioCompress.sampleRate.16000': '16000 Hz',
  'audioCompress.compress': 'Inizia compressione',
  'audioCompress.compressing': 'Compressione...',
  'audioCompress.download': 'Scarica audio',
  // AudioCompress Messages
  'audioCompress.message.compressed': 'Compressione riuscita!',
  'audioCompress.message.failed': 'Compressione fallita, riprova',
  'audioCompress.message.invalidFile': 'Seleziona un file audio!',
  'audioCompress.message.loadError': 'Errore nel caricamento del file audio',

  // Settings
  'settings.title': 'Impostazioni di sistema',
  'settings.description': 'Personalizza la tua esperienza sulla piattaforma AI',
  'settings.notifications.title': 'Notifiche',
  'settings.notifications.description': 'Gestisci come ricevere le notifiche',
  'settings.notifications.email': 'Email',
  'settings.notifications.emailDesc': 'Ricevi aggiornamenti e completamento attività',
  'settings.notifications.push': 'Push',
  'settings.notifications.pushDesc': 'Ricevi messaggi push in tempo reale',
  'settings.notifications.sound': 'Suoni',
  'settings.notifications.soundDesc': 'Riproduci un suono alla notifica',
  'settings.notifications.volume': 'Volume notifiche',
  'settings.notifications.volumeDesc': 'Regola il volume',
  'settings.notifications.marketing': 'Marketing',
  'settings.notifications.marketingDesc': 'Eventi e promozioni della piattaforma',
  'settings.interface.title': 'Aspetto interfaccia',
  'settings.interface.description': 'Personalizza la visualizzazione',
  'settings.interface.theme': 'Tema',
  'settings.interface.themeDesc': 'Scegli il tema',
  'settings.interface.language': 'Lingua',
  'settings.interface.languageDesc': 'Lingua dell\'interfaccia',
  'settings.interface.animation': 'Animazioni',
  'settings.interface.animationDesc': 'Abilita animazioni di transizione',
  'settings.interface.tips': 'Suggerimenti',
  'settings.interface.tipsDesc': 'Mostra guide e suggerimenti',
  'settings.theme.light': 'Chiaro',
  'settings.theme.dark': 'Scuro',
  'settings.theme.auto': 'Auto',
  'settings.ai.title': 'Impostazioni generazione AI',
  'settings.ai.description': 'Ottimizza qualità e prestazioni',
  'settings.ai.autoOptimize': 'Ottimizzazione automatica',
  'settings.ai.autoOptimizeDesc': 'L\'AI ottimizza i parametri automaticamente',
  'settings.ai.quality': 'Qualità generazione',
  'settings.ai.qualityDesc': 'Bilancio velocità/qualità',
  'settings.ai.cloudSync': 'Sincronizzazione cloud',
  'settings.ai.cloudSyncDesc': 'Sincronizza le opere sul cloud',
  'settings.ai.autoSave': 'Salvataggio automatico',
  'settings.ai.autoSaveDesc': 'Salva i risultati dopo la generazione',
  'settings.ai.safetyFilter': 'Filtro contenuti',
  'settings.ai.safetyFilterDesc': 'Filtra contenuti inappropriati',
  'settings.ai.watermark': 'Filigrana',
  'settings.ai.watermarkDesc': 'Aggiungi filigrana alle opere',
  'settings.ai.promptSuggestions': 'Suggerimenti prompt',
  'settings.ai.promptSuggestionsDesc': 'Suggerimenti per ottimizzare i prompt',
  'settings.quality.fast': 'Veloce',
  'settings.quality.balanced': 'Bilanciato',
  'settings.quality.high': 'Alta qualità',
  'settings.privacy.title': 'Privacy e sicurezza',
  'settings.privacy.description': 'Proteggi i tuoi dati personali',
  'settings.privacy.profile': 'Visibilità profilo',
  'settings.privacy.profileDesc': 'Altri utenti possono vedere il tuo profilo',
  'settings.privacy.activity': 'Stato attività',
  'settings.privacy.activityDesc': 'I contatti vedono se sei online',
  'settings.privacy.analytics': 'Raccolta dati analitici',
  'settings.privacy.analyticsDesc': 'Ci aiuti a migliorare il prodotto',
  'settings.privacy.showWorks': 'Visibilità opere',
  'settings.privacy.showWorksDesc': 'Altri possono vedere le tue opere',
  'settings.privacy.allowComments': 'Consenti commenti',
  'settings.privacy.allowCommentsDesc': 'Altri possono commentare',
  'settings.privacy.allowDownload': 'Consenti download',
  'settings.privacy.allowDownloadDesc': 'Altri possono scaricare',
  'settings.performance.title': 'Prestazioni',
  'settings.performance.description': 'Regola le prestazioni di sistema',
  'settings.performance.hardware': 'Accelerazione hardware',
  'settings.performance.hardwareDesc': 'Usa accelerazione GPU',
  'settings.performance.preview': 'Qualità anteprima',
  'settings.performance.previewDesc': 'Livello di qualità anteprima',
  'settings.performance.autoClean': 'Pulizia cache automatica',
  'settings.performance.autoCleanDesc': 'Elimina file temporanei periodicamente',
  'settings.performance.imageCompression': 'Compressione immagini',
  'settings.performance.imageCompressionDesc': 'Comprimi le immagini caricate',
  'settings.performance.lazyLoading': 'Caricamento lazy',
  'settings.performance.lazyLoadingDesc': 'Carica i contenuti in ritardo',
  'settings.preview.low': 'Basso',
  'settings.preview.medium': 'Medio',
  'settings.preview.high': 'Alto',
  'settings.workflow.title': 'Flusso di lavoro',
  'settings.workflow.description': 'Personalizza il flusso AI',
  'settings.workflow.resolution': 'Risoluzione predefinita',
  'settings.workflow.resolutionDesc': 'Dimensione predefinita per le immagini',
  'settings.workflow.saveHistory': 'Salva cronologia',
  'settings.workflow.saveHistoryDesc': 'Salva parametri e prompt',
  'settings.workflow.autoTag': 'Tag intelligenti',
  'settings.workflow.autoTagDesc': 'Aggiungi tag automaticamente',
  'settings.workflow.template': 'Modelli',
  'settings.workflow.templateDesc': 'Abilita modelli di flusso',
  'settings.file.title': 'Gestione file',
  'settings.file.description': 'Archiviazione e backup',
  'settings.file.autoBackup': 'Backup automatico',
  'settings.file.autoBackupDesc': 'Backup automatico dei file importanti',
  'settings.file.backupFrequency': 'Frequenza backup',
  'settings.file.backupFrequencyDesc': 'Scegli la frequenza',
  'settings.file.realtime': 'Tempo reale',
  'settings.file.daily': 'Giornaliero',
  'settings.file.weekly': 'Settimanale',
  'settings.file.autoOrganize': 'Organizzazione automatica',
  'settings.file.autoOrganizeDesc': 'Categorizza i file automaticamente',
  'settings.file.defaultFormat': 'Formato predefinito',
  'settings.file.defaultFormatDesc': 'Formato di salvataggio predefinito',
  'settings.social.title': 'Social',
  'settings.social.description': 'Funzioni social e permessi',
  'settings.social.allowFollow': 'Consenti follow',
  'settings.social.allowFollowDesc': 'Altri possono seguirti',
  'settings.social.allowMessage': 'Consenti messaggi',
  'settings.social.allowMessageDesc': 'Altri possono inviarti messaggi',
  'settings.social.likeNotify': 'Notifiche like',
  'settings.social.likeNotifyDesc': 'Notifica quando ricevi like',
  'settings.social.mentionNotify': 'Notifiche menzioni',
  'settings.social.mentionNotifyDesc': 'Notifica quando vieni menzionato',
  'settings.security.title': 'Sicurezza account',
  'settings.security.description': 'Rafforza la sicurezza',
  'settings.security.twoFactor': 'Autenticazione a due fattori',
  'settings.security.twoFactorDesc': 'Livello di sicurezza aggiuntivo',
  'settings.security.loginNotify': 'Notifiche accesso',
  'settings.security.loginNotifyDesc': 'Notifica accesso da nuovo dispositivo',
  'settings.security.deviceVerify': 'Verifica dispositivo',
  'settings.security.deviceVerifyDesc': 'Dispositivi non autorizzati richiedono verifica',
  'settings.security.autoLogout': 'Disconnessione automatica',
  'settings.security.autoLogoutDesc': 'Esci dopo inattività prolungata',
  'settings.button.save': 'Salva',
  'settings.button.reset': 'Ripristina',
  'settings.badge.on': 'Attivo',
  'settings.badge.recommended': 'Consigliato',
  'settings.message.saveSuccess': 'Impostazioni salvate',
  'settings.message.autoSaved': 'Impostazioni salvate automaticamente',
  'settings.message.saveFailed': 'Salvataggio fallito',
  'settings.message.resetSuccess': 'Impostazioni ripristinate',
  'settings.autoSaveHint': 'Le impostazioni vengono salvate automaticamente',
  'settings.confirm.resetTitle': 'Conferma ripristino',
  'settings.confirm.resetContent': 'Ripristinare tutte le impostazioni ai valori predefiniti?',
  'settings.confirm.reset': 'Ripristina',
  'settings.confirm.cancel': 'Annulla',

  // Prompt Version History
  'prompt.version.label.prompt': 'Prompt',
  'prompt.version.label.negativePrompt': 'Prompt Negativo',
  'prompt.version.label.result': 'Risultato',
}; 